// source: buying/trivia/api/v1/types.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var buying_achievement_tickets_types_v1_types_pb = require('../../../../buying/achievement_tickets/types/v1/types_pb.js');
goog.object.extend(proto, buying_achievement_tickets_types_v1_types_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js');
goog.object.extend(proto, google_protobuf_duration_pb);
goog.exportSymbol('proto.buying.trivia.api.v1.Accuracy', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.AnswerBonusQuestionRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.AnswerBonusQuestionResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.Asset', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.AssetType', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.ClearRankingsCacheRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.ClearRankingsCacheResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.CreateGameRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.CreateGameResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.DeleteGameRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.DeleteGameResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.Direction', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.EndSessionRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.EndSessionResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.Game', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GameConfig', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GameConfig.Asset', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GameConfig.AssetType', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GameConfig.BonusQuestion', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GameConfig.GameImageAssets', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GameConfig.PlayingPeriod', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.QuestionType', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GameProfileResult', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetBonusQuestionRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetBonusQuestionResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetCurrentHostRankingRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetCurrentHostRankingResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetGameRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetGameResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetGlobalRankingsRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetGlobalRankingsResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetLocationRankingsRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetLocationRankingsResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetPublicSessionResultsRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetPublicSessionResultsResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetRankingsRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetRankingsResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetSessionResultsRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetSessionResultsResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetTriviaGamesRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetTriviaGamesResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetTriviaProfileRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.GetTriviaProfileResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.Penalty', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.PenaltyType', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.ProfileHost', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.ProfileRanking', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.ProfileRankingChange', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.Ranking', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.Ranking.Direction', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.RankingsType', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.RedactedGameConfig', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.Round', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.Session', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.SessionType', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.UpdateGameRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.UpdateGameResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse', null, global);
goog.exportSymbol('proto.buying.trivia.api.v1.UserTriviaState', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest.displayName = 'proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse.displayName = 'proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest.displayName = 'proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.displayName = 'proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.displayName = 'proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest.displayName = 'proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.displayName = 'proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.displayName = 'proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.displayName = 'proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.displayName = 'proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.displayName = 'proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.displayName = 'proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.displayName = 'proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.displayName = 'proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.displayName = 'proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetBonusQuestionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetBonusQuestionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetBonusQuestionRequest.displayName = 'proto.buying.trivia.api.v1.GetBonusQuestionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetBonusQuestionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetBonusQuestionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetBonusQuestionResponse.displayName = 'proto.buying.trivia.api.v1.GetBonusQuestionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.AnswerBonusQuestionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.AnswerBonusQuestionRequest.displayName = 'proto.buying.trivia.api.v1.AnswerBonusQuestionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.AnswerBonusQuestionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.displayName = 'proto.buying.trivia.api.v1.AnswerBonusQuestionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.displayName = 'proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.displayName = 'proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.EndSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.EndSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.EndSessionRequest.displayName = 'proto.buying.trivia.api.v1.EndSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.EndSessionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.EndSessionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.EndSessionResponse.displayName = 'proto.buying.trivia.api.v1.EndSessionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetPublicSessionResultsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetPublicSessionResultsRequest.displayName = 'proto.buying.trivia.api.v1.GetPublicSessionResultsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetPublicSessionResultsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.displayName = 'proto.buying.trivia.api.v1.GetPublicSessionResultsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetSessionResultsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetSessionResultsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetSessionResultsRequest.displayName = 'proto.buying.trivia.api.v1.GetSessionResultsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GetSessionResultsResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetSessionResultsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetSessionResultsResponse.displayName = 'proto.buying.trivia.api.v1.GetSessionResultsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.displayName = 'proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetTriviaProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetTriviaProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetTriviaProfileRequest.displayName = 'proto.buying.trivia.api.v1.GetTriviaProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GetTriviaProfileResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetTriviaProfileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetTriviaProfileResponse.displayName = 'proto.buying.trivia.api.v1.GetTriviaProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest.displayName = 'proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.displayName = 'proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GameProfileResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GameProfileResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GameProfileResult.displayName = 'proto.buying.trivia.api.v1.GameProfileResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.ProfileHost = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.ProfileHost, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.ProfileHost.displayName = 'proto.buying.trivia.api.v1.ProfileHost';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.ProfileRanking = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.ProfileRanking, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.ProfileRanking.displayName = 'proto.buying.trivia.api.v1.ProfileRanking';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.ProfileRankingChange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.ProfileRankingChange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.ProfileRankingChange.displayName = 'proto.buying.trivia.api.v1.ProfileRankingChange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetGlobalRankingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetGlobalRankingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetGlobalRankingsRequest.displayName = 'proto.buying.trivia.api.v1.GetGlobalRankingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GetGlobalRankingsResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetGlobalRankingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetGlobalRankingsResponse.displayName = 'proto.buying.trivia.api.v1.GetGlobalRankingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetLocationRankingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetLocationRankingsRequest.displayName = 'proto.buying.trivia.api.v1.GetLocationRankingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GetLocationRankingsResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetLocationRankingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetLocationRankingsResponse.displayName = 'proto.buying.trivia.api.v1.GetLocationRankingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetRankingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetRankingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetRankingsRequest.displayName = 'proto.buying.trivia.api.v1.GetRankingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetRankingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GetRankingsResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetRankingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetRankingsResponse.displayName = 'proto.buying.trivia.api.v1.GetRankingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.Ranking = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.Ranking, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.Ranking.displayName = 'proto.buying.trivia.api.v1.Ranking';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.Accuracy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.Accuracy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.Accuracy.displayName = 'proto.buying.trivia.api.v1.Accuracy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.Asset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.Asset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.Asset.displayName = 'proto.buying.trivia.api.v1.Asset';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.Penalty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.Penalty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.Penalty.displayName = 'proto.buying.trivia.api.v1.Penalty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.Round = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.Round, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.Round.displayName = 'proto.buying.trivia.api.v1.Round';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.Session = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.Session.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.Session, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.Session.displayName = 'proto.buying.trivia.api.v1.Session';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.CreateGameRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.CreateGameRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.CreateGameRequest.displayName = 'proto.buying.trivia.api.v1.CreateGameRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.CreateGameResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.CreateGameResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.CreateGameResponse.displayName = 'proto.buying.trivia.api.v1.CreateGameResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.UpdateGameRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.UpdateGameRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.UpdateGameRequest.displayName = 'proto.buying.trivia.api.v1.UpdateGameRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.UpdateGameResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.UpdateGameResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.UpdateGameResponse.displayName = 'proto.buying.trivia.api.v1.UpdateGameResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.DeleteGameRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.DeleteGameRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.DeleteGameRequest.displayName = 'proto.buying.trivia.api.v1.DeleteGameRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.DeleteGameResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.DeleteGameResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.DeleteGameResponse.displayName = 'proto.buying.trivia.api.v1.DeleteGameResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetGameRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetGameRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetGameRequest.displayName = 'proto.buying.trivia.api.v1.GetGameRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetGameResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetGameResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetGameResponse.displayName = 'proto.buying.trivia.api.v1.GetGameResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetTriviaGamesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GetTriviaGamesRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetTriviaGamesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetTriviaGamesRequest.displayName = 'proto.buying.trivia.api.v1.GetTriviaGamesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetTriviaGamesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GetTriviaGamesResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetTriviaGamesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetTriviaGamesResponse.displayName = 'proto.buying.trivia.api.v1.GetTriviaGamesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.displayName = 'proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.displayName = 'proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.ClearRankingsCacheRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.ClearRankingsCacheRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.ClearRankingsCacheRequest.displayName = 'proto.buying.trivia.api.v1.ClearRankingsCacheRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.ClearRankingsCacheResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.ClearRankingsCacheResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.ClearRankingsCacheResponse.displayName = 'proto.buying.trivia.api.v1.ClearRankingsCacheResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetCurrentHostRankingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetCurrentHostRankingRequest.displayName = 'proto.buying.trivia.api.v1.GetCurrentHostRankingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GetCurrentHostRankingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GetCurrentHostRankingResponse.displayName = 'proto.buying.trivia.api.v1.GetCurrentHostRankingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GameConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GameConfig.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GameConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GameConfig.displayName = 'proto.buying.trivia.api.v1.GameConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.displayName = 'proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.displayName = 'proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GameConfig.GameImageAssets = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GameConfig.GameImageAssets, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GameConfig.GameImageAssets.displayName = 'proto.buying.trivia.api.v1.GameConfig.GameImageAssets';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GameConfig.BonusQuestion.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GameConfig.BonusQuestion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GameConfig.BonusQuestion.displayName = 'proto.buying.trivia.api.v1.GameConfig.BonusQuestion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.repeatedFields_, null);
};
goog.inherits(proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.displayName = 'proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GameConfig.PlayingPeriod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.displayName = 'proto.buying.trivia.api.v1.GameConfig.PlayingPeriod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.GameConfig.Asset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.GameConfig.Asset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.GameConfig.Asset.displayName = 'proto.buying.trivia.api.v1.GameConfig.Asset';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.Game = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.Game, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.Game.displayName = 'proto.buying.trivia.api.v1.Game';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.trivia.api.v1.RedactedGameConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.trivia.api.v1.RedactedGameConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.trivia.api.v1.RedactedGameConfig.displayName = 'proto.buying.trivia.api.v1.RedactedGameConfig';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest}
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest;
  return proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest}
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest} returns this
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse}
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse;
  return proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse}
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.UserEnteredTriviaLobbyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest;
  return proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest} returns this
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
backgroundImageAssetUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
playingPeriod: (f = msg.getPlayingPeriod()) && proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.toObject(includeInstance, f),
sessionType: jspb.Message.getFieldWithDefault(msg, 3, 0),
lobbyAsset: (f = msg.getLobbyAsset()) && proto.buying.trivia.api.v1.Asset.toObject(includeInstance, f),
theme: jspb.Message.getFieldWithDefault(msg, 5, ""),
played: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
lobbyAudioAsset: (f = msg.getLobbyAudioAsset()) && proto.buying.trivia.api.v1.Asset.toObject(includeInstance, f),
liveHowToAsset: (f = msg.getLiveHowToAsset()) && proto.buying.trivia.api.v1.Asset.toObject(includeInstance, f),
scheduleAsset: (f = msg.getScheduleAsset()) && proto.buying.trivia.api.v1.Asset.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse;
  return proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBackgroundImageAssetUrl(value);
      break;
    case 2:
      var value = new proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod;
      reader.readMessage(value,proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.deserializeBinaryFromReader);
      msg.setPlayingPeriod(value);
      break;
    case 3:
      var value = /** @type {!proto.buying.trivia.api.v1.SessionType} */ (reader.readEnum());
      msg.setSessionType(value);
      break;
    case 4:
      var value = new proto.buying.trivia.api.v1.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.Asset.deserializeBinaryFromReader);
      msg.setLobbyAsset(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTheme(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlayed(value);
      break;
    case 7:
      var value = new proto.buying.trivia.api.v1.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.Asset.deserializeBinaryFromReader);
      msg.setLobbyAudioAsset(value);
      break;
    case 8:
      var value = new proto.buying.trivia.api.v1.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.Asset.deserializeBinaryFromReader);
      msg.setLiveHowToAsset(value);
      break;
    case 9:
      var value = new proto.buying.trivia.api.v1.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.Asset.deserializeBinaryFromReader);
      msg.setScheduleAsset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBackgroundImageAssetUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlayingPeriod();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.serializeBinaryToWriter
    );
  }
  f = message.getSessionType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getLobbyAsset();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.buying.trivia.api.v1.Asset.serializeBinaryToWriter
    );
  }
  f = message.getTheme();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPlayed();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getLobbyAudioAsset();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.buying.trivia.api.v1.Asset.serializeBinaryToWriter
    );
  }
  f = message.getLiveHowToAsset();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.buying.trivia.api.v1.Asset.serializeBinaryToWriter
    );
  }
  f = message.getScheduleAsset();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.buying.trivia.api.v1.Asset.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.toObject = function(includeInstance, msg) {
  var f, obj = {
liveStartTimeInclusiveBound: (f = msg.getLiveStartTimeInclusiveBound()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
liveEndTimeExclusiveBound: (f = msg.getLiveEndTimeExclusiveBound()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
nonLiveEndTimeExclusiveBound: (f = msg.getNonLiveEndTimeExclusiveBound()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod;
  return proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLiveStartTimeInclusiveBound(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLiveEndTimeExclusiveBound(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNonLiveEndTimeExclusiveBound(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLiveStartTimeInclusiveBound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLiveEndTimeExclusiveBound();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNonLiveEndTimeExclusiveBound();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp live_start_time_inclusive_bound = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.prototype.getLiveStartTimeInclusiveBound = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod} returns this
*/
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.prototype.setLiveStartTimeInclusiveBound = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod} returns this
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.prototype.clearLiveStartTimeInclusiveBound = function() {
  return this.setLiveStartTimeInclusiveBound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.prototype.hasLiveStartTimeInclusiveBound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp live_end_time_exclusive_bound = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.prototype.getLiveEndTimeExclusiveBound = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod} returns this
*/
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.prototype.setLiveEndTimeExclusiveBound = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod} returns this
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.prototype.clearLiveEndTimeExclusiveBound = function() {
  return this.setLiveEndTimeExclusiveBound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.prototype.hasLiveEndTimeExclusiveBound = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp non_live_end_time_exclusive_bound = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.prototype.getNonLiveEndTimeExclusiveBound = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod} returns this
*/
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.prototype.setNonLiveEndTimeExclusiveBound = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod} returns this
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.prototype.clearNonLiveEndTimeExclusiveBound = function() {
  return this.setNonLiveEndTimeExclusiveBound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod.prototype.hasNonLiveEndTimeExclusiveBound = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string background_image_asset_url = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.getBackgroundImageAssetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} returns this
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.setBackgroundImageAssetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PlayingPeriod playing_period = 2;
 * @return {?proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.getPlayingPeriod = function() {
  return /** @type{?proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod, 2));
};


/**
 * @param {?proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.PlayingPeriod|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} returns this
*/
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.setPlayingPeriod = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} returns this
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.clearPlayingPeriod = function() {
  return this.setPlayingPeriod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.hasPlayingPeriod = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SessionType session_type = 3;
 * @return {!proto.buying.trivia.api.v1.SessionType}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.getSessionType = function() {
  return /** @type {!proto.buying.trivia.api.v1.SessionType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.buying.trivia.api.v1.SessionType} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} returns this
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.setSessionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Asset lobby_asset = 4;
 * @return {?proto.buying.trivia.api.v1.Asset}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.getLobbyAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Asset, 4));
};


/**
 * @param {?proto.buying.trivia.api.v1.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} returns this
*/
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.setLobbyAsset = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} returns this
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.clearLobbyAsset = function() {
  return this.setLobbyAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.hasLobbyAsset = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string theme = 5;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.getTheme = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} returns this
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.setTheme = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool played = 6;
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.getPlayed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} returns this
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.setPlayed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional Asset lobby_audio_asset = 7;
 * @return {?proto.buying.trivia.api.v1.Asset}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.getLobbyAudioAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Asset, 7));
};


/**
 * @param {?proto.buying.trivia.api.v1.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} returns this
*/
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.setLobbyAudioAsset = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} returns this
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.clearLobbyAudioAsset = function() {
  return this.setLobbyAudioAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.hasLobbyAudioAsset = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Asset live_how_to_asset = 8;
 * @return {?proto.buying.trivia.api.v1.Asset}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.getLiveHowToAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Asset, 8));
};


/**
 * @param {?proto.buying.trivia.api.v1.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} returns this
*/
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.setLiveHowToAsset = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} returns this
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.clearLiveHowToAsset = function() {
  return this.setLiveHowToAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.hasLiveHowToAsset = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Asset schedule_asset = 9;
 * @return {?proto.buying.trivia.api.v1.Asset}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.getScheduleAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Asset, 9));
};


/**
 * @param {?proto.buying.trivia.api.v1.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} returns this
*/
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.setScheduleAsset = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse} returns this
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.clearScheduleAsset = function() {
  return this.setScheduleAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetTriviaLobbyDetailsResponse.prototype.hasScheduleAsset = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest;
  return proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
answerablePrimaryQuestionsList: jspb.Message.toObjectList(msg.getAnswerablePrimaryQuestionsList(),
    proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.toObject, includeInstance),
sessionStartTime: (f = msg.getSessionStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
playingPeriod: (f = msg.getPlayingPeriod()) && proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.toObject(includeInstance, f),
sessionType: jspb.Message.getFieldWithDefault(msg, 4, 0),
theme: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse;
  return proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion;
      reader.readMessage(value,proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.deserializeBinaryFromReader);
      msg.addAnswerablePrimaryQuestions(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSessionStartTime(value);
      break;
    case 3:
      var value = new proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod;
      reader.readMessage(value,proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.deserializeBinaryFromReader);
      msg.setPlayingPeriod(value);
      break;
    case 4:
      var value = /** @type {!proto.buying.trivia.api.v1.SessionType} */ (reader.readEnum());
      msg.setSessionType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTheme(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnswerablePrimaryQuestionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.serializeBinaryToWriter
    );
  }
  f = message.getSessionStartTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPlayingPeriod();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.serializeBinaryToWriter
    );
  }
  f = message.getSessionType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTheme();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.toObject = function(includeInstance, msg) {
  var f, obj = {
questionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
questionText: jspb.Message.getFieldWithDefault(msg, 2, ""),
questionAsset: (f = msg.getQuestionAsset()) && proto.buying.trivia.api.v1.Asset.toObject(includeInstance, f),
answersList: jspb.Message.toObjectList(msg.getAnswersList(),
    proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion;
  return proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionText(value);
      break;
    case 3:
      var value = new proto.buying.trivia.api.v1.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.Asset.deserializeBinaryFromReader);
      msg.setQuestionAsset(value);
      break;
    case 4:
      var value = new proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer;
      reader.readMessage(value,proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.deserializeBinaryFromReader);
      msg.addAnswers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuestionAsset();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.buying.trivia.api.v1.Asset.serializeBinaryToWriter
    );
  }
  f = message.getAnswersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.toObject = function(includeInstance, msg) {
  var f, obj = {
answerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
answerText: jspb.Message.getFieldWithDefault(msg, 2, ""),
answerAsset: (f = msg.getAnswerAsset()) && proto.buying.trivia.api.v1.Asset.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer;
  return proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerText(value);
      break;
    case 3:
      var value = new proto.buying.trivia.api.v1.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.Asset.deserializeBinaryFromReader);
      msg.setAnswerAsset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnswerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAnswerText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAnswerAsset();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.buying.trivia.api.v1.Asset.serializeBinaryToWriter
    );
  }
};


/**
 * optional string answer_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.prototype.getAnswerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.prototype.setAnswerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string answer_text = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.prototype.getAnswerText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.prototype.setAnswerText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Asset answer_asset = 3;
 * @return {?proto.buying.trivia.api.v1.Asset}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.prototype.getAnswerAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Asset, 3));
};


/**
 * @param {?proto.buying.trivia.api.v1.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer} returns this
*/
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.prototype.setAnswerAsset = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.prototype.clearAnswerAsset = function() {
  return this.setAnswerAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer.prototype.hasAnswerAsset = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string question_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string question_text = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.prototype.getQuestionText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.prototype.setQuestionText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Asset question_asset = 3;
 * @return {?proto.buying.trivia.api.v1.Asset}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.prototype.getQuestionAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Asset, 3));
};


/**
 * @param {?proto.buying.trivia.api.v1.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion} returns this
*/
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.prototype.setQuestionAsset = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.prototype.clearQuestionAsset = function() {
  return this.setQuestionAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.prototype.hasQuestionAsset = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated Answer answers = 4;
 * @return {!Array<!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer>}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.prototype.getAnswersList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer, 4));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer>} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion} returns this
*/
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.prototype.setAnswersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.prototype.addAnswers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.Answer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion.prototype.clearAnswersList = function() {
  return this.setAnswersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.toObject = function(includeInstance, msg) {
  var f, obj = {
liveStartTimeInclusiveBound: (f = msg.getLiveStartTimeInclusiveBound()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
liveEndTimeExclusiveBound: (f = msg.getLiveEndTimeExclusiveBound()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
nonLiveDuration: (f = msg.getNonLiveDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
nonLiveEndTimeExclusiveBound: (f = msg.getNonLiveEndTimeExclusiveBound()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod;
  return proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLiveStartTimeInclusiveBound(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLiveEndTimeExclusiveBound(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setNonLiveDuration(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNonLiveEndTimeExclusiveBound(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLiveStartTimeInclusiveBound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLiveEndTimeExclusiveBound();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNonLiveDuration();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getNonLiveEndTimeExclusiveBound();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp live_start_time_inclusive_bound = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.getLiveStartTimeInclusiveBound = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod} returns this
*/
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.setLiveStartTimeInclusiveBound = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.clearLiveStartTimeInclusiveBound = function() {
  return this.setLiveStartTimeInclusiveBound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.hasLiveStartTimeInclusiveBound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp live_end_time_exclusive_bound = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.getLiveEndTimeExclusiveBound = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod} returns this
*/
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.setLiveEndTimeExclusiveBound = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.clearLiveEndTimeExclusiveBound = function() {
  return this.setLiveEndTimeExclusiveBound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.hasLiveEndTimeExclusiveBound = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Duration non_live_duration = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.getNonLiveDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod} returns this
*/
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.setNonLiveDuration = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.clearNonLiveDuration = function() {
  return this.setNonLiveDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.hasNonLiveDuration = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp non_live_end_time_exclusive_bound = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.getNonLiveEndTimeExclusiveBound = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod} returns this
*/
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.setNonLiveEndTimeExclusiveBound = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.clearNonLiveEndTimeExclusiveBound = function() {
  return this.setNonLiveEndTimeExclusiveBound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod.prototype.hasNonLiveEndTimeExclusiveBound = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated AnswerablePrimaryQuestion answerable_primary_questions = 1;
 * @return {!Array<!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion>}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.getAnswerablePrimaryQuestionsList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion, 1));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion>} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse} returns this
*/
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.setAnswerablePrimaryQuestionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.addAnswerablePrimaryQuestions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.AnswerablePrimaryQuestion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.clearAnswerablePrimaryQuestionsList = function() {
  return this.setAnswerablePrimaryQuestionsList([]);
};


/**
 * optional google.protobuf.Timestamp session_start_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.getSessionStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse} returns this
*/
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.setSessionStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.clearSessionStartTime = function() {
  return this.setSessionStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.hasSessionStartTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PlayingPeriod playing_period = 3;
 * @return {?proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.getPlayingPeriod = function() {
  return /** @type{?proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod, 3));
};


/**
 * @param {?proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.PlayingPeriod|undefined} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse} returns this
*/
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.setPlayingPeriod = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.clearPlayingPeriod = function() {
  return this.setPlayingPeriod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.hasPlayingPeriod = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SessionType session_type = 4;
 * @return {!proto.buying.trivia.api.v1.SessionType}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.getSessionType = function() {
  return /** @type {!proto.buying.trivia.api.v1.SessionType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.buying.trivia.api.v1.SessionType} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.setSessionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string theme = 5;
 * @return {string}
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.getTheme = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse} returns this
 */
proto.buying.trivia.api.v1.StartSessionOrGetPrimaryQuestionsResponse.prototype.setTheme = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, ""),
questionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
answerId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest;
  return proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAnswerId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest} returns this
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string question_id = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest} returns this
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string answer_id = 3;
 * @return {string}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.prototype.getAnswerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest} returns this
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionRequest.prototype.setAnswerId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
answeredPrimaryQuestion: (f = msg.getAnsweredPrimaryQuestion()) && proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.toObject(includeInstance, f),
streakTriggered: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
primaryQuestionResults: (f = msg.getPrimaryQuestionResults()) && proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.toObject(includeInstance, f),
session: (f = msg.getSession()) && proto.buying.trivia.api.v1.Session.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse;
  return proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion;
      reader.readMessage(value,proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.deserializeBinaryFromReader);
      msg.setAnsweredPrimaryQuestion(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStreakTriggered(value);
      break;
    case 3:
      var value = new proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults;
      reader.readMessage(value,proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.deserializeBinaryFromReader);
      msg.setPrimaryQuestionResults(value);
      break;
    case 4:
      var value = new proto.buying.trivia.api.v1.Session;
      reader.readMessage(value,proto.buying.trivia.api.v1.Session.deserializeBinaryFromReader);
      msg.setSession(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnsweredPrimaryQuestion();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.serializeBinaryToWriter
    );
  }
  f = message.getStreakTriggered();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getPrimaryQuestionResults();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.serializeBinaryToWriter
    );
  }
  f = message.getSession();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.buying.trivia.api.v1.Session.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.toObject = function(includeInstance, msg) {
  var f, obj = {
questionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userAnswerId: jspb.Message.getFieldWithDefault(msg, 2, ""),
correctAnswerId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion;
  return proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserAnswerId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrectAnswerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserAnswerId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCorrectAnswerId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string question_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion} returns this
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_answer_id = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.prototype.getUserAnswerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion} returns this
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.prototype.setUserAnswerId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string correct_answer_id = 3;
 * @return {string}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.prototype.getCorrectAnswerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion} returns this
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion.prototype.setCorrectAnswerId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.toObject = function(includeInstance, msg) {
  var f, obj = {
answerFrequenciesList: jspb.Message.toObjectList(msg.getAnswerFrequenciesList(),
    proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults;
  return proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = new proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency;
      reader.readMessage(value,proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.deserializeBinaryFromReader);
      msg.addAnswerFrequencies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnswerFrequenciesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.toObject = function(includeInstance, msg) {
  var f, obj = {
answerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
percentage: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency;
  return proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPercentage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnswerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPercentage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string answer_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.prototype.getAnswerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency} returns this
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.prototype.setAnswerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 percentage = 2;
 * @return {number}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.prototype.getPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency} returns this
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency.prototype.setPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated AnswerFrequency answer_frequencies = 4;
 * @return {!Array<!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency>}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.prototype.getAnswerFrequenciesList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency, 4));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency>} value
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults} returns this
*/
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.prototype.setAnswerFrequenciesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.prototype.addAnswerFrequencies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.AnswerFrequency, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults} returns this
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults.prototype.clearAnswerFrequenciesList = function() {
  return this.setAnswerFrequenciesList([]);
};


/**
 * optional AnsweredPrimaryQuestion answered_primary_question = 1;
 * @return {?proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.getAnsweredPrimaryQuestion = function() {
  return /** @type{?proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion, 1));
};


/**
 * @param {?proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.AnsweredPrimaryQuestion|undefined} value
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse} returns this
*/
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.setAnsweredPrimaryQuestion = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse} returns this
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.clearAnsweredPrimaryQuestion = function() {
  return this.setAnsweredPrimaryQuestion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.hasAnsweredPrimaryQuestion = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool streak_triggered = 2;
 * @return {boolean}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.getStreakTriggered = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse} returns this
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.setStreakTriggered = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional PrimaryQuestionResults primary_question_results = 3;
 * @return {?proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.getPrimaryQuestionResults = function() {
  return /** @type{?proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults, 3));
};


/**
 * @param {?proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.PrimaryQuestionResults|undefined} value
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse} returns this
*/
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.setPrimaryQuestionResults = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse} returns this
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.clearPrimaryQuestionResults = function() {
  return this.setPrimaryQuestionResults(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.hasPrimaryQuestionResults = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Session session = 4;
 * @return {?proto.buying.trivia.api.v1.Session}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.getSession = function() {
  return /** @type{?proto.buying.trivia.api.v1.Session} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Session, 4));
};


/**
 * @param {?proto.buying.trivia.api.v1.Session|undefined} value
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse} returns this
*/
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.setSession = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse} returns this
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.clearSession = function() {
  return this.setSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.AnswerPrimaryQuestionResponse.prototype.hasSession = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetBonusQuestionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetBonusQuestionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetBonusQuestionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetBonusQuestionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetBonusQuestionRequest}
 */
proto.buying.trivia.api.v1.GetBonusQuestionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetBonusQuestionRequest;
  return proto.buying.trivia.api.v1.GetBonusQuestionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetBonusQuestionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetBonusQuestionRequest}
 */
proto.buying.trivia.api.v1.GetBonusQuestionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetBonusQuestionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetBonusQuestionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetBonusQuestionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetBonusQuestionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetBonusQuestionRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetBonusQuestionRequest} returns this
 */
proto.buying.trivia.api.v1.GetBonusQuestionRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetBonusQuestionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetBonusQuestionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetBonusQuestionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetBonusQuestionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
hasBonusQuestion: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
questionText: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetBonusQuestionResponse}
 */
proto.buying.trivia.api.v1.GetBonusQuestionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetBonusQuestionResponse;
  return proto.buying.trivia.api.v1.GetBonusQuestionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetBonusQuestionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetBonusQuestionResponse}
 */
proto.buying.trivia.api.v1.GetBonusQuestionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasBonusQuestion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetBonusQuestionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetBonusQuestionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetBonusQuestionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetBonusQuestionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasBonusQuestion();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getQuestionText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool has_bonus_question = 1;
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetBonusQuestionResponse.prototype.getHasBonusQuestion = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.trivia.api.v1.GetBonusQuestionResponse} returns this
 */
proto.buying.trivia.api.v1.GetBonusQuestionResponse.prototype.setHasBonusQuestion = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string question_text = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetBonusQuestionResponse.prototype.getQuestionText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetBonusQuestionResponse} returns this
 */
proto.buying.trivia.api.v1.GetBonusQuestionResponse.prototype.setQuestionText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.AnswerBonusQuestionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.AnswerBonusQuestionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, ""),
spaceId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionRequest}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.AnswerBonusQuestionRequest;
  return proto.buying.trivia.api.v1.AnswerBonusQuestionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.AnswerBonusQuestionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionRequest}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSpaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.AnswerBonusQuestionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.AnswerBonusQuestionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSpaceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionRequest} returns this
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string space_id = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionRequest.prototype.getSpaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionRequest} returns this
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionRequest.prototype.setSpaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
answeredBonusQuestion: (f = msg.getAnsweredBonusQuestion()) && proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.toObject(includeInstance, f),
session: (f = msg.getSession()) && proto.buying.trivia.api.v1.Session.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.AnswerBonusQuestionResponse;
  return proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion;
      reader.readMessage(value,proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.deserializeBinaryFromReader);
      msg.setAnsweredBonusQuestion(value);
      break;
    case 2:
      var value = new proto.buying.trivia.api.v1.Session;
      reader.readMessage(value,proto.buying.trivia.api.v1.Session.deserializeBinaryFromReader);
      msg.setSession(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnsweredBonusQuestion();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.serializeBinaryToWriter
    );
  }
  f = message.getSession();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.buying.trivia.api.v1.Session.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.toObject = function(includeInstance, msg) {
  var f, obj = {
productList: jspb.Message.toObjectList(msg.getProductList(),
    proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.toObject, includeInstance),
totalCorrect: jspb.Message.getFieldWithDefault(msg, 2, 0),
totalAnswered: jspb.Message.getFieldWithDefault(msg, 3, 0),
ticketsEarned: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion;
  return proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product;
      reader.readMessage(value,proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.deserializeBinaryFromReader);
      msg.addProduct(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCorrect(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalAnswered(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketsEarned(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.serializeBinaryToWriter
    );
  }
  f = message.getTotalCorrect();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalAnswered();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTicketsEarned();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.toObject = function(includeInstance, msg) {
  var f, obj = {
productName: jspb.Message.getFieldWithDefault(msg, 1, ""),
correct: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
productImage: (f = msg.getProductImage()) && proto.buying.trivia.api.v1.Asset.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product;
  return proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCorrect(value);
      break;
    case 3:
      var value = new proto.buying.trivia.api.v1.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.Asset.deserializeBinaryFromReader);
      msg.setProductImage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCorrect();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getProductImage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.buying.trivia.api.v1.Asset.serializeBinaryToWriter
    );
  }
};


/**
 * optional string product_name = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product} returns this
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.prototype.setProductName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool correct = 2;
 * @return {boolean}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.prototype.getCorrect = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product} returns this
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.prototype.setCorrect = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional Asset product_image = 3;
 * @return {?proto.buying.trivia.api.v1.Asset}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.prototype.getProductImage = function() {
  return /** @type{?proto.buying.trivia.api.v1.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Asset, 3));
};


/**
 * @param {?proto.buying.trivia.api.v1.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product} returns this
*/
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.prototype.setProductImage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product} returns this
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.prototype.clearProductImage = function() {
  return this.setProductImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product.prototype.hasProductImage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated Product product = 1;
 * @return {!Array<!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product>}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.prototype.getProductList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product, 1));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product>} value
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion} returns this
*/
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.prototype.setProductList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.prototype.addProduct = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.Product, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion} returns this
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.prototype.clearProductList = function() {
  return this.setProductList([]);
};


/**
 * optional int32 total_correct = 2;
 * @return {number}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.prototype.getTotalCorrect = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion} returns this
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.prototype.setTotalCorrect = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 total_answered = 3;
 * @return {number}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.prototype.getTotalAnswered = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion} returns this
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.prototype.setTotalAnswered = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 tickets_earned = 4;
 * @return {number}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.prototype.getTicketsEarned = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion} returns this
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion.prototype.setTicketsEarned = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional AnsweredBonusQuestion answered_bonus_question = 1;
 * @return {?proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.prototype.getAnsweredBonusQuestion = function() {
  return /** @type{?proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion, 1));
};


/**
 * @param {?proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.AnsweredBonusQuestion|undefined} value
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse} returns this
*/
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.prototype.setAnsweredBonusQuestion = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse} returns this
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.prototype.clearAnsweredBonusQuestion = function() {
  return this.setAnsweredBonusQuestion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.prototype.hasAnsweredBonusQuestion = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Session session = 2;
 * @return {?proto.buying.trivia.api.v1.Session}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.prototype.getSession = function() {
  return /** @type{?proto.buying.trivia.api.v1.Session} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Session, 2));
};


/**
 * @param {?proto.buying.trivia.api.v1.Session|undefined} value
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse} returns this
*/
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.prototype.setSession = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.AnswerBonusQuestionResponse} returns this
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.prototype.clearSession = function() {
  return this.setSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.AnswerBonusQuestionResponse.prototype.hasSession = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.EndSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.EndSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.EndSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.EndSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.EndSessionRequest}
 */
proto.buying.trivia.api.v1.EndSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.EndSessionRequest;
  return proto.buying.trivia.api.v1.EndSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.EndSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.EndSessionRequest}
 */
proto.buying.trivia.api.v1.EndSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.EndSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.EndSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.EndSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.EndSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.EndSessionRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.EndSessionRequest} returns this
 */
proto.buying.trivia.api.v1.EndSessionRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.EndSessionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.EndSessionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.EndSessionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.EndSessionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.EndSessionResponse}
 */
proto.buying.trivia.api.v1.EndSessionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.EndSessionResponse;
  return proto.buying.trivia.api.v1.EndSessionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.EndSessionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.EndSessionResponse}
 */
proto.buying.trivia.api.v1.EndSessionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.EndSessionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.EndSessionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.EndSessionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.EndSessionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetPublicSessionResultsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetPublicSessionResultsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsRequest}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetPublicSessionResultsRequest;
  return proto.buying.trivia.api.v1.GetPublicSessionResultsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetPublicSessionResultsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsRequest}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetPublicSessionResultsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetPublicSessionResultsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsRequest} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsRequest} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.repeatedFields_ = [7,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
isLive: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
host: jspb.Message.getFieldWithDefault(msg, 2, ""),
theme: jspb.Message.getFieldWithDefault(msg, 3, ""),
round: (f = msg.getRound()) && proto.buying.trivia.api.v1.Round.toObject(includeInstance, f),
accuracy: (f = msg.getAccuracy()) && proto.buying.trivia.api.v1.Accuracy.toObject(includeInstance, f),
speed: (f = msg.getSpeed()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
penaltiesList: jspb.Message.toObjectList(msg.getPenaltiesList(),
    proto.buying.trivia.api.v1.Penalty.toObject, includeInstance),
finishTime: (f = msg.getFinishTime()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
globalTriviaRanking: (f = msg.getGlobalTriviaRanking()) && proto.buying.trivia.api.v1.ProfileRanking.toObject(includeInstance, f),
countryTriviaRanking: (f = msg.getCountryTriviaRanking()) && proto.buying.trivia.api.v1.ProfileRanking.toObject(includeInstance, f),
ticketsEarned: jspb.Message.getFieldWithDefault(msg, 11, 0),
badgeTypesEarnedList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
username: jspb.Message.getFieldWithDefault(msg, 13, ""),
flagAssetUrl: jspb.Message.getFieldWithDefault(msg, 14, ""),
countryCode: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetPublicSessionResultsResponse;
  return proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLive(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTheme(value);
      break;
    case 4:
      var value = new proto.buying.trivia.api.v1.Round;
      reader.readMessage(value,proto.buying.trivia.api.v1.Round.deserializeBinaryFromReader);
      msg.setRound(value);
      break;
    case 5:
      var value = new proto.buying.trivia.api.v1.Accuracy;
      reader.readMessage(value,proto.buying.trivia.api.v1.Accuracy.deserializeBinaryFromReader);
      msg.setAccuracy(value);
      break;
    case 6:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setSpeed(value);
      break;
    case 7:
      var value = new proto.buying.trivia.api.v1.Penalty;
      reader.readMessage(value,proto.buying.trivia.api.v1.Penalty.deserializeBinaryFromReader);
      msg.addPenalties(value);
      break;
    case 8:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setFinishTime(value);
      break;
    case 9:
      var value = new proto.buying.trivia.api.v1.ProfileRanking;
      reader.readMessage(value,proto.buying.trivia.api.v1.ProfileRanking.deserializeBinaryFromReader);
      msg.setGlobalTriviaRanking(value);
      break;
    case 10:
      var value = new proto.buying.trivia.api.v1.ProfileRanking;
      reader.readMessage(value,proto.buying.trivia.api.v1.ProfileRanking.deserializeBinaryFromReader);
      msg.setCountryTriviaRanking(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketsEarned(value);
      break;
    case 12:
      var values = /** @type {!Array<!proto.buying.achievement_tickets.types.v1.AchievementBadgeType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addBadgeTypesEarned(values[i]);
      }
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlagAssetUrl(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsLive();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTheme();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRound();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.buying.trivia.api.v1.Round.serializeBinaryToWriter
    );
  }
  f = message.getAccuracy();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.buying.trivia.api.v1.Accuracy.serializeBinaryToWriter
    );
  }
  f = message.getSpeed();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getPenaltiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.buying.trivia.api.v1.Penalty.serializeBinaryToWriter
    );
  }
  f = message.getFinishTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getGlobalTriviaRanking();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.buying.trivia.api.v1.ProfileRanking.serializeBinaryToWriter
    );
  }
  f = message.getCountryTriviaRanking();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.buying.trivia.api.v1.ProfileRanking.serializeBinaryToWriter
    );
  }
  f = message.getTicketsEarned();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getBadgeTypesEarnedList();
  if (f.length > 0) {
    writer.writePackedEnum(
      12,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getFlagAssetUrl();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional bool is_live = 1;
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getIsLive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setIsLive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string host = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string theme = 3;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getTheme = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setTheme = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Round round = 4;
 * @return {?proto.buying.trivia.api.v1.Round}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getRound = function() {
  return /** @type{?proto.buying.trivia.api.v1.Round} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Round, 4));
};


/**
 * @param {?proto.buying.trivia.api.v1.Round|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setRound = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.clearRound = function() {
  return this.setRound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.hasRound = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Accuracy accuracy = 5;
 * @return {?proto.buying.trivia.api.v1.Accuracy}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getAccuracy = function() {
  return /** @type{?proto.buying.trivia.api.v1.Accuracy} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Accuracy, 5));
};


/**
 * @param {?proto.buying.trivia.api.v1.Accuracy|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setAccuracy = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.clearAccuracy = function() {
  return this.setAccuracy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.hasAccuracy = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Duration speed = 6;
 * @return {?proto.google.protobuf.Duration}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getSpeed = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 6));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setSpeed = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.clearSpeed = function() {
  return this.setSpeed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.hasSpeed = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated Penalty penalties = 7;
 * @return {!Array<!proto.buying.trivia.api.v1.Penalty>}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getPenaltiesList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.Penalty>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.Penalty, 7));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.Penalty>} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setPenaltiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.Penalty=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.Penalty}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.addPenalties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.buying.trivia.api.v1.Penalty, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.clearPenaltiesList = function() {
  return this.setPenaltiesList([]);
};


/**
 * optional google.protobuf.Duration finish_time = 8;
 * @return {?proto.google.protobuf.Duration}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getFinishTime = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 8));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setFinishTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.clearFinishTime = function() {
  return this.setFinishTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.hasFinishTime = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional ProfileRanking global_trivia_ranking = 9;
 * @return {?proto.buying.trivia.api.v1.ProfileRanking}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getGlobalTriviaRanking = function() {
  return /** @type{?proto.buying.trivia.api.v1.ProfileRanking} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.ProfileRanking, 9));
};


/**
 * @param {?proto.buying.trivia.api.v1.ProfileRanking|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setGlobalTriviaRanking = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.clearGlobalTriviaRanking = function() {
  return this.setGlobalTriviaRanking(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.hasGlobalTriviaRanking = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional ProfileRanking country_trivia_ranking = 10;
 * @return {?proto.buying.trivia.api.v1.ProfileRanking}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getCountryTriviaRanking = function() {
  return /** @type{?proto.buying.trivia.api.v1.ProfileRanking} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.ProfileRanking, 10));
};


/**
 * @param {?proto.buying.trivia.api.v1.ProfileRanking|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setCountryTriviaRanking = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.clearCountryTriviaRanking = function() {
  return this.setCountryTriviaRanking(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.hasCountryTriviaRanking = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional int32 tickets_earned = 11;
 * @return {number}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getTicketsEarned = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setTicketsEarned = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * repeated buying.achievement_tickets.types.v1.AchievementBadgeType badge_types_earned = 12;
 * @return {!Array<!proto.buying.achievement_tickets.types.v1.AchievementBadgeType>}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getBadgeTypesEarnedList = function() {
  return /** @type {!Array<!proto.buying.achievement_tickets.types.v1.AchievementBadgeType>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<!proto.buying.achievement_tickets.types.v1.AchievementBadgeType>} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setBadgeTypesEarnedList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {!proto.buying.achievement_tickets.types.v1.AchievementBadgeType} value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.addBadgeTypesEarned = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.clearBadgeTypesEarnedList = function() {
  return this.setBadgeTypesEarnedList([]);
};


/**
 * optional string username = 13;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string flag_asset_url = 14;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getFlagAssetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setFlagAssetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string country_code = 15;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetPublicSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicSessionResultsResponse.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetSessionResultsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetSessionResultsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetSessionResultsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetSessionResultsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsRequest}
 */
proto.buying.trivia.api.v1.GetSessionResultsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetSessionResultsRequest;
  return proto.buying.trivia.api.v1.GetSessionResultsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetSessionResultsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsRequest}
 */
proto.buying.trivia.api.v1.GetSessionResultsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetSessionResultsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetSessionResultsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetSessionResultsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetSessionResultsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetSessionResultsRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsRequest} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.repeatedFields_ = [7,12,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetSessionResultsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetSessionResultsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
isLive: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
host: jspb.Message.getFieldWithDefault(msg, 2, ""),
theme: jspb.Message.getFieldWithDefault(msg, 3, ""),
round: (f = msg.getRound()) && proto.buying.trivia.api.v1.Round.toObject(includeInstance, f),
accuracy: (f = msg.getAccuracy()) && proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.toObject(includeInstance, f),
speed: (f = msg.getSpeed()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
penaltiesList: jspb.Message.toObjectList(msg.getPenaltiesList(),
    proto.buying.trivia.api.v1.Penalty.toObject, includeInstance),
finishTime: (f = msg.getFinishTime()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
globalTriviaRanking: (f = msg.getGlobalTriviaRanking()) && proto.buying.trivia.api.v1.ProfileRanking.toObject(includeInstance, f),
countryTriviaRanking: (f = msg.getCountryTriviaRanking()) && proto.buying.trivia.api.v1.ProfileRanking.toObject(includeInstance, f),
ticketsEarned: jspb.Message.getFieldWithDefault(msg, 11, 0),
badgesEarnedList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
bonusQuestionAccuracy: (f = msg.getBonusQuestionAccuracy()) && proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.toObject(includeInstance, f),
badgeTypesEarnedList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
bonusQuestionShareDescription: jspb.Message.getFieldWithDefault(msg, 15, ""),
streakBonusTickets: jspb.Message.getFieldWithDefault(msg, 16, 0),
maxPossibleTickets: jspb.Message.getFieldWithDefault(msg, 17, 0),
gameAssetUrl: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetSessionResultsResponse;
  return proto.buying.trivia.api.v1.GetSessionResultsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetSessionResultsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLive(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTheme(value);
      break;
    case 4:
      var value = new proto.buying.trivia.api.v1.Round;
      reader.readMessage(value,proto.buying.trivia.api.v1.Round.deserializeBinaryFromReader);
      msg.setRound(value);
      break;
    case 5:
      var value = new proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy;
      reader.readMessage(value,proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.deserializeBinaryFromReader);
      msg.setAccuracy(value);
      break;
    case 6:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setSpeed(value);
      break;
    case 7:
      var value = new proto.buying.trivia.api.v1.Penalty;
      reader.readMessage(value,proto.buying.trivia.api.v1.Penalty.deserializeBinaryFromReader);
      msg.addPenalties(value);
      break;
    case 8:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setFinishTime(value);
      break;
    case 9:
      var value = new proto.buying.trivia.api.v1.ProfileRanking;
      reader.readMessage(value,proto.buying.trivia.api.v1.ProfileRanking.deserializeBinaryFromReader);
      msg.setGlobalTriviaRanking(value);
      break;
    case 10:
      var value = new proto.buying.trivia.api.v1.ProfileRanking;
      reader.readMessage(value,proto.buying.trivia.api.v1.ProfileRanking.deserializeBinaryFromReader);
      msg.setCountryTriviaRanking(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketsEarned(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addBadgesEarned(value);
      break;
    case 13:
      var value = new proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy;
      reader.readMessage(value,proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.deserializeBinaryFromReader);
      msg.setBonusQuestionAccuracy(value);
      break;
    case 14:
      var values = /** @type {!Array<!proto.buying.achievement_tickets.types.v1.AchievementBadgeType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addBadgeTypesEarned(values[i]);
      }
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setBonusQuestionShareDescription(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStreakBonusTickets(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxPossibleTickets(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameAssetUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetSessionResultsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetSessionResultsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsLive();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTheme();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRound();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.buying.trivia.api.v1.Round.serializeBinaryToWriter
    );
  }
  f = message.getAccuracy();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.serializeBinaryToWriter
    );
  }
  f = message.getSpeed();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getPenaltiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.buying.trivia.api.v1.Penalty.serializeBinaryToWriter
    );
  }
  f = message.getFinishTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getGlobalTriviaRanking();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.buying.trivia.api.v1.ProfileRanking.serializeBinaryToWriter
    );
  }
  f = message.getCountryTriviaRanking();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.buying.trivia.api.v1.ProfileRanking.serializeBinaryToWriter
    );
  }
  f = message.getTicketsEarned();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getBadgesEarnedList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
  f = message.getBonusQuestionAccuracy();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.serializeBinaryToWriter
    );
  }
  f = message.getBadgeTypesEarnedList();
  if (f.length > 0) {
    writer.writePackedEnum(
      14,
      f
    );
  }
  f = message.getBonusQuestionShareDescription();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getStreakBonusTickets();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getMaxPossibleTickets();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getGameAssetUrl();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.toObject = function(includeInstance, msg) {
  var f, obj = {
totalCorrect: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalAnswered: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy;
  return proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCorrect(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalAnswered(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalCorrect();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalAnswered();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 total_correct = 1;
 * @return {number}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.prototype.getTotalCorrect = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.prototype.setTotalCorrect = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 total_answered = 2;
 * @return {number}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.prototype.getTotalAnswered = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy.prototype.setTotalAnswered = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool is_live = 1;
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getIsLive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setIsLive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string host = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string theme = 3;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getTheme = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setTheme = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Round round = 4;
 * @return {?proto.buying.trivia.api.v1.Round}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getRound = function() {
  return /** @type{?proto.buying.trivia.api.v1.Round} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Round, 4));
};


/**
 * @param {?proto.buying.trivia.api.v1.Round|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setRound = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.clearRound = function() {
  return this.setRound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.hasRound = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Accuracy accuracy = 5;
 * @return {?proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getAccuracy = function() {
  return /** @type{?proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy, 5));
};


/**
 * @param {?proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setAccuracy = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.clearAccuracy = function() {
  return this.setAccuracy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.hasAccuracy = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Duration speed = 6;
 * @return {?proto.google.protobuf.Duration}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getSpeed = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 6));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setSpeed = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.clearSpeed = function() {
  return this.setSpeed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.hasSpeed = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated Penalty penalties = 7;
 * @return {!Array<!proto.buying.trivia.api.v1.Penalty>}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getPenaltiesList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.Penalty>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.Penalty, 7));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.Penalty>} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setPenaltiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.Penalty=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.Penalty}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.addPenalties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.buying.trivia.api.v1.Penalty, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.clearPenaltiesList = function() {
  return this.setPenaltiesList([]);
};


/**
 * optional google.protobuf.Duration finish_time = 8;
 * @return {?proto.google.protobuf.Duration}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getFinishTime = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 8));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setFinishTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.clearFinishTime = function() {
  return this.setFinishTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.hasFinishTime = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional ProfileRanking global_trivia_ranking = 9;
 * @return {?proto.buying.trivia.api.v1.ProfileRanking}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getGlobalTriviaRanking = function() {
  return /** @type{?proto.buying.trivia.api.v1.ProfileRanking} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.ProfileRanking, 9));
};


/**
 * @param {?proto.buying.trivia.api.v1.ProfileRanking|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setGlobalTriviaRanking = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.clearGlobalTriviaRanking = function() {
  return this.setGlobalTriviaRanking(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.hasGlobalTriviaRanking = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional ProfileRanking country_trivia_ranking = 10;
 * @return {?proto.buying.trivia.api.v1.ProfileRanking}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getCountryTriviaRanking = function() {
  return /** @type{?proto.buying.trivia.api.v1.ProfileRanking} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.ProfileRanking, 10));
};


/**
 * @param {?proto.buying.trivia.api.v1.ProfileRanking|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setCountryTriviaRanking = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.clearCountryTriviaRanking = function() {
  return this.setCountryTriviaRanking(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.hasCountryTriviaRanking = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional int32 tickets_earned = 11;
 * @return {number}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getTicketsEarned = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setTicketsEarned = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * repeated string badges_earned = 12;
 * @return {!Array<string>}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getBadgesEarnedList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setBadgesEarnedList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.addBadgesEarned = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.clearBadgesEarnedList = function() {
  return this.setBadgesEarnedList([]);
};


/**
 * optional Accuracy bonus_question_accuracy = 13;
 * @return {?proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getBonusQuestionAccuracy = function() {
  return /** @type{?proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy, 13));
};


/**
 * @param {?proto.buying.trivia.api.v1.GetSessionResultsResponse.Accuracy|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
*/
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setBonusQuestionAccuracy = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.clearBonusQuestionAccuracy = function() {
  return this.setBonusQuestionAccuracy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.hasBonusQuestionAccuracy = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * repeated buying.achievement_tickets.types.v1.AchievementBadgeType badge_types_earned = 14;
 * @return {!Array<!proto.buying.achievement_tickets.types.v1.AchievementBadgeType>}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getBadgeTypesEarnedList = function() {
  return /** @type {!Array<!proto.buying.achievement_tickets.types.v1.AchievementBadgeType>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<!proto.buying.achievement_tickets.types.v1.AchievementBadgeType>} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setBadgeTypesEarnedList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {!proto.buying.achievement_tickets.types.v1.AchievementBadgeType} value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.addBadgeTypesEarned = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.clearBadgeTypesEarnedList = function() {
  return this.setBadgeTypesEarnedList([]);
};


/**
 * optional string bonus_question_share_description = 15;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getBonusQuestionShareDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setBonusQuestionShareDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional int32 streak_bonus_tickets = 16;
 * @return {number}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getStreakBonusTickets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setStreakBonusTickets = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 max_possible_tickets = 17;
 * @return {number}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getMaxPossibleTickets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setMaxPossibleTickets = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional string game_asset_url = 18;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.getGameAssetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetSessionResultsResponse} returns this
 */
proto.buying.trivia.api.v1.GetSessionResultsResponse.prototype.setGameAssetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetTriviaProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetTriviaProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetTriviaProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetTriviaProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetTriviaProfileRequest}
 */
proto.buying.trivia.api.v1.GetTriviaProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetTriviaProfileRequest;
  return proto.buying.trivia.api.v1.GetTriviaProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetTriviaProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetTriviaProfileRequest}
 */
proto.buying.trivia.api.v1.GetTriviaProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetTriviaProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetTriviaProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetTriviaProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetTriviaProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetTriviaProfileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetTriviaProfileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
hostsList: jspb.Message.toObjectList(msg.getHostsList(),
    proto.buying.trivia.api.v1.ProfileHost.toObject, includeInstance),
resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.buying.trivia.api.v1.GameProfileResult.toObject, includeInstance),
dailyRankings: (f = msg.getDailyRankings()) && proto.buying.trivia.api.v1.ProfileRanking.toObject(includeInstance, f),
totalRankings: (f = msg.getTotalRankings()) && proto.buying.trivia.api.v1.ProfileRanking.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetTriviaProfileResponse}
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetTriviaProfileResponse;
  return proto.buying.trivia.api.v1.GetTriviaProfileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetTriviaProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetTriviaProfileResponse}
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.trivia.api.v1.ProfileHost;
      reader.readMessage(value,proto.buying.trivia.api.v1.ProfileHost.deserializeBinaryFromReader);
      msg.addHosts(value);
      break;
    case 2:
      var value = new proto.buying.trivia.api.v1.GameProfileResult;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameProfileResult.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    case 3:
      var value = new proto.buying.trivia.api.v1.ProfileRanking;
      reader.readMessage(value,proto.buying.trivia.api.v1.ProfileRanking.deserializeBinaryFromReader);
      msg.setDailyRankings(value);
      break;
    case 4:
      var value = new proto.buying.trivia.api.v1.ProfileRanking;
      reader.readMessage(value,proto.buying.trivia.api.v1.ProfileRanking.deserializeBinaryFromReader);
      msg.setTotalRankings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetTriviaProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetTriviaProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHostsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.trivia.api.v1.ProfileHost.serializeBinaryToWriter
    );
  }
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.buying.trivia.api.v1.GameProfileResult.serializeBinaryToWriter
    );
  }
  f = message.getDailyRankings();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.buying.trivia.api.v1.ProfileRanking.serializeBinaryToWriter
    );
  }
  f = message.getTotalRankings();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.buying.trivia.api.v1.ProfileRanking.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ProfileHost hosts = 1;
 * @return {!Array<!proto.buying.trivia.api.v1.ProfileHost>}
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.getHostsList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.ProfileHost>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.ProfileHost, 1));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.ProfileHost>} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaProfileResponse} returns this
*/
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.setHostsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.ProfileHost=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.ProfileHost}
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.addHosts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.trivia.api.v1.ProfileHost, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetTriviaProfileResponse} returns this
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.clearHostsList = function() {
  return this.setHostsList([]);
};


/**
 * repeated GameProfileResult results = 2;
 * @return {!Array<!proto.buying.trivia.api.v1.GameProfileResult>}
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.GameProfileResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.GameProfileResult, 2));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.GameProfileResult>} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaProfileResponse} returns this
*/
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.GameProfileResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.GameProfileResult}
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.buying.trivia.api.v1.GameProfileResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetTriviaProfileResponse} returns this
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};


/**
 * optional ProfileRanking daily_rankings = 3;
 * @return {?proto.buying.trivia.api.v1.ProfileRanking}
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.getDailyRankings = function() {
  return /** @type{?proto.buying.trivia.api.v1.ProfileRanking} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.ProfileRanking, 3));
};


/**
 * @param {?proto.buying.trivia.api.v1.ProfileRanking|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaProfileResponse} returns this
*/
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.setDailyRankings = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetTriviaProfileResponse} returns this
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.clearDailyRankings = function() {
  return this.setDailyRankings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.hasDailyRankings = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ProfileRanking total_rankings = 4;
 * @return {?proto.buying.trivia.api.v1.ProfileRanking}
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.getTotalRankings = function() {
  return /** @type{?proto.buying.trivia.api.v1.ProfileRanking} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.ProfileRanking, 4));
};


/**
 * @param {?proto.buying.trivia.api.v1.ProfileRanking|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaProfileResponse} returns this
*/
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.setTotalRankings = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetTriviaProfileResponse} returns this
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.clearTotalRankings = function() {
  return this.setTotalRankings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetTriviaProfileResponse.prototype.hasTotalRankings = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest}
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest;
  return proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest}
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest} returns this
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
hostsList: jspb.Message.toObjectList(msg.getHostsList(),
    proto.buying.trivia.api.v1.ProfileHost.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse}
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse;
  return proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse}
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.trivia.api.v1.ProfileHost;
      reader.readMessage(value,proto.buying.trivia.api.v1.ProfileHost.deserializeBinaryFromReader);
      msg.addHosts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHostsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.trivia.api.v1.ProfileHost.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ProfileHost hosts = 1;
 * @return {!Array<!proto.buying.trivia.api.v1.ProfileHost>}
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.prototype.getHostsList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.ProfileHost>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.ProfileHost, 1));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.ProfileHost>} value
 * @return {!proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse} returns this
*/
proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.prototype.setHostsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.ProfileHost=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.ProfileHost}
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.prototype.addHosts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.trivia.api.v1.ProfileHost, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse} returns this
 */
proto.buying.trivia.api.v1.GetPublicTriviaProfileResponse.prototype.clearHostsList = function() {
  return this.setHostsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GameProfileResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GameProfileResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameProfileResult.toObject = function(includeInstance, msg) {
  var f, obj = {
gameAssetUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
totalCorrect: jspb.Message.getFieldWithDefault(msg, 2, 0),
totalAnswered: jspb.Message.getFieldWithDefault(msg, 3, 0),
speed: (f = msg.getSpeed()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
gameId: jspb.Message.getFieldWithDefault(msg, 5, ""),
round: (f = msg.getRound()) && proto.buying.trivia.api.v1.Round.toObject(includeInstance, f),
theme: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GameProfileResult}
 */
proto.buying.trivia.api.v1.GameProfileResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GameProfileResult;
  return proto.buying.trivia.api.v1.GameProfileResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GameProfileResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GameProfileResult}
 */
proto.buying.trivia.api.v1.GameProfileResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameAssetUrl(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCorrect(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalAnswered(value);
      break;
    case 4:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setSpeed(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    case 6:
      var value = new proto.buying.trivia.api.v1.Round;
      reader.readMessage(value,proto.buying.trivia.api.v1.Round.deserializeBinaryFromReader);
      msg.setRound(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTheme(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GameProfileResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GameProfileResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameProfileResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameAssetUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalCorrect();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalAnswered();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSpeed();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRound();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.buying.trivia.api.v1.Round.serializeBinaryToWriter
    );
  }
  f = message.getTheme();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string game_asset_url = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.getGameAssetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameProfileResult} returns this
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.setGameAssetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 total_correct = 2;
 * @return {number}
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.getTotalCorrect = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GameProfileResult} returns this
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.setTotalCorrect = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 total_answered = 3;
 * @return {number}
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.getTotalAnswered = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GameProfileResult} returns this
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.setTotalAnswered = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.Duration speed = 4;
 * @return {?proto.google.protobuf.Duration}
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.getSpeed = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 4));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameProfileResult} returns this
*/
proto.buying.trivia.api.v1.GameProfileResult.prototype.setSpeed = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameProfileResult} returns this
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.clearSpeed = function() {
  return this.setSpeed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.hasSpeed = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string game_id = 5;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameProfileResult} returns this
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Round round = 6;
 * @return {?proto.buying.trivia.api.v1.Round}
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.getRound = function() {
  return /** @type{?proto.buying.trivia.api.v1.Round} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Round, 6));
};


/**
 * @param {?proto.buying.trivia.api.v1.Round|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameProfileResult} returns this
*/
proto.buying.trivia.api.v1.GameProfileResult.prototype.setRound = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameProfileResult} returns this
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.clearRound = function() {
  return this.setRound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.hasRound = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string theme = 7;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.getTheme = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameProfileResult} returns this
 */
proto.buying.trivia.api.v1.GameProfileResult.prototype.setTheme = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.ProfileHost.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.ProfileHost.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.ProfileHost} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.ProfileHost.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
globalRanking: (f = msg.getGlobalRanking()) && proto.buying.trivia.api.v1.ProfileRanking.toObject(includeInstance, f),
localRanking: (f = msg.getLocalRanking()) && proto.buying.trivia.api.v1.ProfileRanking.toObject(includeInstance, f),
userTriviaState: jspb.Message.getFieldWithDefault(msg, 4, 0),
rankingsAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.ProfileHost}
 */
proto.buying.trivia.api.v1.ProfileHost.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.ProfileHost;
  return proto.buying.trivia.api.v1.ProfileHost.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.ProfileHost} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.ProfileHost}
 */
proto.buying.trivia.api.v1.ProfileHost.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.buying.trivia.api.v1.ProfileRanking;
      reader.readMessage(value,proto.buying.trivia.api.v1.ProfileRanking.deserializeBinaryFromReader);
      msg.setGlobalRanking(value);
      break;
    case 3:
      var value = new proto.buying.trivia.api.v1.ProfileRanking;
      reader.readMessage(value,proto.buying.trivia.api.v1.ProfileRanking.deserializeBinaryFromReader);
      msg.setLocalRanking(value);
      break;
    case 4:
      var value = /** @type {!proto.buying.trivia.api.v1.UserTriviaState} */ (reader.readEnum());
      msg.setUserTriviaState(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRankingsAvailable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.ProfileHost.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.ProfileHost.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.ProfileHost} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.ProfileHost.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGlobalRanking();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.buying.trivia.api.v1.ProfileRanking.serializeBinaryToWriter
    );
  }
  f = message.getLocalRanking();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.buying.trivia.api.v1.ProfileRanking.serializeBinaryToWriter
    );
  }
  f = message.getUserTriviaState();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getRankingsAvailable();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.ProfileHost.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.ProfileHost} returns this
 */
proto.buying.trivia.api.v1.ProfileHost.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ProfileRanking global_ranking = 2;
 * @return {?proto.buying.trivia.api.v1.ProfileRanking}
 */
proto.buying.trivia.api.v1.ProfileHost.prototype.getGlobalRanking = function() {
  return /** @type{?proto.buying.trivia.api.v1.ProfileRanking} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.ProfileRanking, 2));
};


/**
 * @param {?proto.buying.trivia.api.v1.ProfileRanking|undefined} value
 * @return {!proto.buying.trivia.api.v1.ProfileHost} returns this
*/
proto.buying.trivia.api.v1.ProfileHost.prototype.setGlobalRanking = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.ProfileHost} returns this
 */
proto.buying.trivia.api.v1.ProfileHost.prototype.clearGlobalRanking = function() {
  return this.setGlobalRanking(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.ProfileHost.prototype.hasGlobalRanking = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ProfileRanking local_ranking = 3;
 * @return {?proto.buying.trivia.api.v1.ProfileRanking}
 */
proto.buying.trivia.api.v1.ProfileHost.prototype.getLocalRanking = function() {
  return /** @type{?proto.buying.trivia.api.v1.ProfileRanking} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.ProfileRanking, 3));
};


/**
 * @param {?proto.buying.trivia.api.v1.ProfileRanking|undefined} value
 * @return {!proto.buying.trivia.api.v1.ProfileHost} returns this
*/
proto.buying.trivia.api.v1.ProfileHost.prototype.setLocalRanking = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.ProfileHost} returns this
 */
proto.buying.trivia.api.v1.ProfileHost.prototype.clearLocalRanking = function() {
  return this.setLocalRanking(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.ProfileHost.prototype.hasLocalRanking = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional UserTriviaState user_trivia_state = 4;
 * @return {!proto.buying.trivia.api.v1.UserTriviaState}
 */
proto.buying.trivia.api.v1.ProfileHost.prototype.getUserTriviaState = function() {
  return /** @type {!proto.buying.trivia.api.v1.UserTriviaState} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.buying.trivia.api.v1.UserTriviaState} value
 * @return {!proto.buying.trivia.api.v1.ProfileHost} returns this
 */
proto.buying.trivia.api.v1.ProfileHost.prototype.setUserTriviaState = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional bool rankings_available = 5;
 * @return {boolean}
 */
proto.buying.trivia.api.v1.ProfileHost.prototype.getRankingsAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.trivia.api.v1.ProfileHost} returns this
 */
proto.buying.trivia.api.v1.ProfileHost.prototype.setRankingsAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.ProfileRanking.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.ProfileRanking} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.ProfileRanking.toObject = function(includeInstance, msg) {
  var f, obj = {
rank: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalUsers: jspb.Message.getFieldWithDefault(msg, 2, 0),
rankingChange: (f = msg.getRankingChange()) && proto.buying.trivia.api.v1.ProfileRankingChange.toObject(includeInstance, f),
countryCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
flagAssetUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
finishTime: (f = msg.getFinishTime()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.ProfileRanking}
 */
proto.buying.trivia.api.v1.ProfileRanking.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.ProfileRanking;
  return proto.buying.trivia.api.v1.ProfileRanking.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.ProfileRanking} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.ProfileRanking}
 */
proto.buying.trivia.api.v1.ProfileRanking.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalUsers(value);
      break;
    case 3:
      var value = new proto.buying.trivia.api.v1.ProfileRankingChange;
      reader.readMessage(value,proto.buying.trivia.api.v1.ProfileRankingChange.deserializeBinaryFromReader);
      msg.setRankingChange(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlagAssetUrl(value);
      break;
    case 6:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setFinishTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.ProfileRanking.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.ProfileRanking} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.ProfileRanking.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalUsers();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getRankingChange();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.buying.trivia.api.v1.ProfileRankingChange.serializeBinaryToWriter
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFlagAssetUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFinishTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 rank = 1;
 * @return {number}
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.ProfileRanking} returns this
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 total_users = 2;
 * @return {number}
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.getTotalUsers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.ProfileRanking} returns this
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.setTotalUsers = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional ProfileRankingChange ranking_change = 3;
 * @return {?proto.buying.trivia.api.v1.ProfileRankingChange}
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.getRankingChange = function() {
  return /** @type{?proto.buying.trivia.api.v1.ProfileRankingChange} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.ProfileRankingChange, 3));
};


/**
 * @param {?proto.buying.trivia.api.v1.ProfileRankingChange|undefined} value
 * @return {!proto.buying.trivia.api.v1.ProfileRanking} returns this
*/
proto.buying.trivia.api.v1.ProfileRanking.prototype.setRankingChange = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.ProfileRanking} returns this
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.clearRankingChange = function() {
  return this.setRankingChange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.hasRankingChange = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string country_code = 4;
 * @return {string}
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.ProfileRanking} returns this
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string flag_asset_url = 5;
 * @return {string}
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.getFlagAssetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.ProfileRanking} returns this
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.setFlagAssetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Duration finish_time = 6;
 * @return {?proto.google.protobuf.Duration}
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.getFinishTime = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 6));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.buying.trivia.api.v1.ProfileRanking} returns this
*/
proto.buying.trivia.api.v1.ProfileRanking.prototype.setFinishTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.ProfileRanking} returns this
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.clearFinishTime = function() {
  return this.setFinishTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.ProfileRanking.prototype.hasFinishTime = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.ProfileRankingChange.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.ProfileRankingChange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.ProfileRankingChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.ProfileRankingChange.toObject = function(includeInstance, msg) {
  var f, obj = {
direction: jspb.Message.getFieldWithDefault(msg, 1, 0),
rankingChangeAmount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.ProfileRankingChange}
 */
proto.buying.trivia.api.v1.ProfileRankingChange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.ProfileRankingChange;
  return proto.buying.trivia.api.v1.ProfileRankingChange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.ProfileRankingChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.ProfileRankingChange}
 */
proto.buying.trivia.api.v1.ProfileRankingChange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.trivia.api.v1.Direction} */ (reader.readEnum());
      msg.setDirection(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRankingChangeAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.ProfileRankingChange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.ProfileRankingChange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.ProfileRankingChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.ProfileRankingChange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRankingChangeAmount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional Direction direction = 1;
 * @return {!proto.buying.trivia.api.v1.Direction}
 */
proto.buying.trivia.api.v1.ProfileRankingChange.prototype.getDirection = function() {
  return /** @type {!proto.buying.trivia.api.v1.Direction} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.trivia.api.v1.Direction} value
 * @return {!proto.buying.trivia.api.v1.ProfileRankingChange} returns this
 */
proto.buying.trivia.api.v1.ProfileRankingChange.prototype.setDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 ranking_change_amount = 2;
 * @return {number}
 */
proto.buying.trivia.api.v1.ProfileRankingChange.prototype.getRankingChangeAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.ProfileRankingChange} returns this
 */
proto.buying.trivia.api.v1.ProfileRankingChange.prototype.setRankingChangeAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetGlobalRankingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetGlobalRankingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetGlobalRankingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
paginationToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
host: jspb.Message.getFieldWithDefault(msg, 2, ""),
gameId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetGlobalRankingsRequest}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetGlobalRankingsRequest;
  return proto.buying.trivia.api.v1.GetGlobalRankingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetGlobalRankingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetGlobalRankingsRequest}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetGlobalRankingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetGlobalRankingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetGlobalRankingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaginationToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string pagination_token = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsRequest.prototype.getPaginationToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetGlobalRankingsRequest} returns this
 */
proto.buying.trivia.api.v1.GetGlobalRankingsRequest.prototype.setPaginationToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string host = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsRequest.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetGlobalRankingsRequest} returns this
 */
proto.buying.trivia.api.v1.GetGlobalRankingsRequest.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string game_id = 3;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetGlobalRankingsRequest} returns this
 */
proto.buying.trivia.api.v1.GetGlobalRankingsRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetGlobalRankingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetGlobalRankingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
rankingsList: jspb.Message.toObjectList(msg.getRankingsList(),
    proto.buying.trivia.api.v1.Ranking.toObject, includeInstance),
paginationToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
rankingLimit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetGlobalRankingsResponse}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetGlobalRankingsResponse;
  return proto.buying.trivia.api.v1.GetGlobalRankingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetGlobalRankingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetGlobalRankingsResponse}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.trivia.api.v1.Ranking;
      reader.readMessage(value,proto.buying.trivia.api.v1.Ranking.deserializeBinaryFromReader);
      msg.addRankings(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationToken(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRankingLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetGlobalRankingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetGlobalRankingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRankingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.trivia.api.v1.Ranking.serializeBinaryToWriter
    );
  }
  f = message.getPaginationToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRankingLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated Ranking rankings = 1;
 * @return {!Array<!proto.buying.trivia.api.v1.Ranking>}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.prototype.getRankingsList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.Ranking>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.Ranking, 1));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.Ranking>} value
 * @return {!proto.buying.trivia.api.v1.GetGlobalRankingsResponse} returns this
*/
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.prototype.setRankingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.Ranking=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.Ranking}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.prototype.addRankings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.trivia.api.v1.Ranking, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetGlobalRankingsResponse} returns this
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.prototype.clearRankingsList = function() {
  return this.setRankingsList([]);
};


/**
 * optional string pagination_token = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.prototype.getPaginationToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetGlobalRankingsResponse} returns this
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.prototype.setPaginationToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 ranking_limit = 3;
 * @return {number}
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.prototype.getRankingLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GetGlobalRankingsResponse} returns this
 */
proto.buying.trivia.api.v1.GetGlobalRankingsResponse.prototype.setRankingLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetLocationRankingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetLocationRankingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
paginationToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
host: jspb.Message.getFieldWithDefault(msg, 2, ""),
gameId: jspb.Message.getFieldWithDefault(msg, 3, ""),
userId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetLocationRankingsRequest}
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetLocationRankingsRequest;
  return proto.buying.trivia.api.v1.GetLocationRankingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetLocationRankingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetLocationRankingsRequest}
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetLocationRankingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetLocationRankingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaginationToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string pagination_token = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest.prototype.getPaginationToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetLocationRankingsRequest} returns this
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest.prototype.setPaginationToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string host = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetLocationRankingsRequest} returns this
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string game_id = 3;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetLocationRankingsRequest} returns this
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string user_id = 4;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetLocationRankingsRequest} returns this
 */
proto.buying.trivia.api.v1.GetLocationRankingsRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetLocationRankingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetLocationRankingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
rankingsList: jspb.Message.toObjectList(msg.getRankingsList(),
    proto.buying.trivia.api.v1.Ranking.toObject, includeInstance),
paginationToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
rankingLimit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetLocationRankingsResponse}
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetLocationRankingsResponse;
  return proto.buying.trivia.api.v1.GetLocationRankingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetLocationRankingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetLocationRankingsResponse}
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.trivia.api.v1.Ranking;
      reader.readMessage(value,proto.buying.trivia.api.v1.Ranking.deserializeBinaryFromReader);
      msg.addRankings(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationToken(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRankingLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetLocationRankingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetLocationRankingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRankingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.trivia.api.v1.Ranking.serializeBinaryToWriter
    );
  }
  f = message.getPaginationToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRankingLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated Ranking rankings = 1;
 * @return {!Array<!proto.buying.trivia.api.v1.Ranking>}
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse.prototype.getRankingsList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.Ranking>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.Ranking, 1));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.Ranking>} value
 * @return {!proto.buying.trivia.api.v1.GetLocationRankingsResponse} returns this
*/
proto.buying.trivia.api.v1.GetLocationRankingsResponse.prototype.setRankingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.Ranking=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.Ranking}
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse.prototype.addRankings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.trivia.api.v1.Ranking, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetLocationRankingsResponse} returns this
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse.prototype.clearRankingsList = function() {
  return this.setRankingsList([]);
};


/**
 * optional string pagination_token = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse.prototype.getPaginationToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetLocationRankingsResponse} returns this
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse.prototype.setPaginationToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 ranking_limit = 3;
 * @return {number}
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse.prototype.getRankingLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GetLocationRankingsResponse} returns this
 */
proto.buying.trivia.api.v1.GetLocationRankingsResponse.prototype.setRankingLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetRankingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetRankingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetRankingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetRankingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
rankingsType: jspb.Message.getFieldWithDefault(msg, 1, 0),
paginationToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
day: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetRankingsRequest}
 */
proto.buying.trivia.api.v1.GetRankingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetRankingsRequest;
  return proto.buying.trivia.api.v1.GetRankingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetRankingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetRankingsRequest}
 */
proto.buying.trivia.api.v1.GetRankingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.trivia.api.v1.RankingsType} */ (reader.readEnum());
      msg.setRankingsType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationToken(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDay(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetRankingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetRankingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetRankingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetRankingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRankingsType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getPaginationToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDay();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional RankingsType rankings_type = 1;
 * @return {!proto.buying.trivia.api.v1.RankingsType}
 */
proto.buying.trivia.api.v1.GetRankingsRequest.prototype.getRankingsType = function() {
  return /** @type {!proto.buying.trivia.api.v1.RankingsType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.trivia.api.v1.RankingsType} value
 * @return {!proto.buying.trivia.api.v1.GetRankingsRequest} returns this
 */
proto.buying.trivia.api.v1.GetRankingsRequest.prototype.setRankingsType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string pagination_token = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetRankingsRequest.prototype.getPaginationToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetRankingsRequest} returns this
 */
proto.buying.trivia.api.v1.GetRankingsRequest.prototype.setPaginationToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 day = 3;
 * @return {number}
 */
proto.buying.trivia.api.v1.GetRankingsRequest.prototype.getDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GetRankingsRequest} returns this
 */
proto.buying.trivia.api.v1.GetRankingsRequest.prototype.setDay = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GetRankingsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetRankingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetRankingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetRankingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
rankingsList: jspb.Message.toObjectList(msg.getRankingsList(),
    proto.buying.trivia.api.v1.Ranking.toObject, includeInstance),
paginationToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
numDaysOfRankingsAvailable: jspb.Message.getFieldWithDefault(msg, 3, 0),
rankingDisplayLimit: jspb.Message.getFieldWithDefault(msg, 4, 0),
userRank: (f = msg.getUserRank()) && proto.buying.trivia.api.v1.Ranking.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetRankingsResponse}
 */
proto.buying.trivia.api.v1.GetRankingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetRankingsResponse;
  return proto.buying.trivia.api.v1.GetRankingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetRankingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetRankingsResponse}
 */
proto.buying.trivia.api.v1.GetRankingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.trivia.api.v1.Ranking;
      reader.readMessage(value,proto.buying.trivia.api.v1.Ranking.deserializeBinaryFromReader);
      msg.addRankings(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationToken(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumDaysOfRankingsAvailable(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRankingDisplayLimit(value);
      break;
    case 5:
      var value = new proto.buying.trivia.api.v1.Ranking;
      reader.readMessage(value,proto.buying.trivia.api.v1.Ranking.deserializeBinaryFromReader);
      msg.setUserRank(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetRankingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetRankingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetRankingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRankingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.trivia.api.v1.Ranking.serializeBinaryToWriter
    );
  }
  f = message.getPaginationToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNumDaysOfRankingsAvailable();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRankingDisplayLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getUserRank();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.buying.trivia.api.v1.Ranking.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Ranking rankings = 1;
 * @return {!Array<!proto.buying.trivia.api.v1.Ranking>}
 */
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.getRankingsList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.Ranking>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.Ranking, 1));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.Ranking>} value
 * @return {!proto.buying.trivia.api.v1.GetRankingsResponse} returns this
*/
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.setRankingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.Ranking=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.Ranking}
 */
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.addRankings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.trivia.api.v1.Ranking, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetRankingsResponse} returns this
 */
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.clearRankingsList = function() {
  return this.setRankingsList([]);
};


/**
 * optional string pagination_token = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.getPaginationToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetRankingsResponse} returns this
 */
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.setPaginationToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 num_days_of_rankings_available = 3;
 * @return {number}
 */
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.getNumDaysOfRankingsAvailable = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GetRankingsResponse} returns this
 */
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.setNumDaysOfRankingsAvailable = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 ranking_display_limit = 4;
 * @return {number}
 */
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.getRankingDisplayLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GetRankingsResponse} returns this
 */
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.setRankingDisplayLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional Ranking user_rank = 5;
 * @return {?proto.buying.trivia.api.v1.Ranking}
 */
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.getUserRank = function() {
  return /** @type{?proto.buying.trivia.api.v1.Ranking} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Ranking, 5));
};


/**
 * @param {?proto.buying.trivia.api.v1.Ranking|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetRankingsResponse} returns this
*/
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.setUserRank = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetRankingsResponse} returns this
 */
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.clearUserRank = function() {
  return this.setUserRank(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetRankingsResponse.prototype.hasUserRank = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.Ranking.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.Ranking.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.Ranking} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.Ranking.toObject = function(includeInstance, msg) {
  var f, obj = {
rank: jspb.Message.getFieldWithDefault(msg, 1, 0),
redactedUsername: jspb.Message.getFieldWithDefault(msg, 2, ""),
country: jspb.Message.getFieldWithDefault(msg, 3, ""),
finishTime: (f = msg.getFinishTime()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
rankingChange: jspb.Message.getFieldWithDefault(msg, 5, 0),
flagAssetUrl: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.Ranking}
 */
proto.buying.trivia.api.v1.Ranking.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.Ranking;
  return proto.buying.trivia.api.v1.Ranking.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.Ranking} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.Ranking}
 */
proto.buying.trivia.api.v1.Ranking.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedactedUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 4:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setFinishTime(value);
      break;
    case 5:
      var value = /** @type {!proto.buying.trivia.api.v1.Ranking.Direction} */ (reader.readEnum());
      msg.setRankingChange(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlagAssetUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.Ranking.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.Ranking.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.Ranking} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.Ranking.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRedactedUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFinishTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getRankingChange();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getFlagAssetUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.buying.trivia.api.v1.Ranking.Direction = {
  RANKING_DIRECTION_INVALID: 0,
  RANKING_DIRECTION_UP: 1,
  RANKING_DIRECTION_DOWN: 2,
  RANKING_DIRECTION_SAME: 3
};

/**
 * optional int32 rank = 1;
 * @return {number}
 */
proto.buying.trivia.api.v1.Ranking.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.Ranking} returns this
 */
proto.buying.trivia.api.v1.Ranking.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string redacted_username = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.Ranking.prototype.getRedactedUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.Ranking} returns this
 */
proto.buying.trivia.api.v1.Ranking.prototype.setRedactedUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string country = 3;
 * @return {string}
 */
proto.buying.trivia.api.v1.Ranking.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.Ranking} returns this
 */
proto.buying.trivia.api.v1.Ranking.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Duration finish_time = 4;
 * @return {?proto.google.protobuf.Duration}
 */
proto.buying.trivia.api.v1.Ranking.prototype.getFinishTime = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 4));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.buying.trivia.api.v1.Ranking} returns this
*/
proto.buying.trivia.api.v1.Ranking.prototype.setFinishTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.Ranking} returns this
 */
proto.buying.trivia.api.v1.Ranking.prototype.clearFinishTime = function() {
  return this.setFinishTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.Ranking.prototype.hasFinishTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Direction ranking_change = 5;
 * @return {!proto.buying.trivia.api.v1.Ranking.Direction}
 */
proto.buying.trivia.api.v1.Ranking.prototype.getRankingChange = function() {
  return /** @type {!proto.buying.trivia.api.v1.Ranking.Direction} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.buying.trivia.api.v1.Ranking.Direction} value
 * @return {!proto.buying.trivia.api.v1.Ranking} returns this
 */
proto.buying.trivia.api.v1.Ranking.prototype.setRankingChange = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string flag_asset_url = 6;
 * @return {string}
 */
proto.buying.trivia.api.v1.Ranking.prototype.getFlagAssetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.Ranking} returns this
 */
proto.buying.trivia.api.v1.Ranking.prototype.setFlagAssetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.Accuracy.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.Accuracy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.Accuracy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.Accuracy.toObject = function(includeInstance, msg) {
  var f, obj = {
totalCorrect: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalAnswered: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.Accuracy}
 */
proto.buying.trivia.api.v1.Accuracy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.Accuracy;
  return proto.buying.trivia.api.v1.Accuracy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.Accuracy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.Accuracy}
 */
proto.buying.trivia.api.v1.Accuracy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCorrect(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalAnswered(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.Accuracy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.Accuracy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.Accuracy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.Accuracy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalCorrect();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalAnswered();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 total_correct = 1;
 * @return {number}
 */
proto.buying.trivia.api.v1.Accuracy.prototype.getTotalCorrect = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.Accuracy} returns this
 */
proto.buying.trivia.api.v1.Accuracy.prototype.setTotalCorrect = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 total_answered = 2;
 * @return {number}
 */
proto.buying.trivia.api.v1.Accuracy.prototype.getTotalAnswered = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.Accuracy} returns this
 */
proto.buying.trivia.api.v1.Accuracy.prototype.setTotalAnswered = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.Asset.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.Asset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.Asset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.Asset.toObject = function(includeInstance, msg) {
  var f, obj = {
assetType: jspb.Message.getFieldWithDefault(msg, 1, 0),
url: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.Asset}
 */
proto.buying.trivia.api.v1.Asset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.Asset;
  return proto.buying.trivia.api.v1.Asset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.Asset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.Asset}
 */
proto.buying.trivia.api.v1.Asset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.trivia.api.v1.AssetType} */ (reader.readEnum());
      msg.setAssetType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.Asset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.Asset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.Asset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.Asset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssetType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional AssetType asset_type = 1;
 * @return {!proto.buying.trivia.api.v1.AssetType}
 */
proto.buying.trivia.api.v1.Asset.prototype.getAssetType = function() {
  return /** @type {!proto.buying.trivia.api.v1.AssetType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.trivia.api.v1.AssetType} value
 * @return {!proto.buying.trivia.api.v1.Asset} returns this
 */
proto.buying.trivia.api.v1.Asset.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.Asset.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.Asset} returns this
 */
proto.buying.trivia.api.v1.Asset.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.Penalty.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.Penalty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.Penalty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.Penalty.toObject = function(includeInstance, msg) {
  var f, obj = {
penaltyType: jspb.Message.getFieldWithDefault(msg, 1, 0),
duration: (f = msg.getDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.Penalty}
 */
proto.buying.trivia.api.v1.Penalty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.Penalty;
  return proto.buying.trivia.api.v1.Penalty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.Penalty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.Penalty}
 */
proto.buying.trivia.api.v1.Penalty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.trivia.api.v1.PenaltyType} */ (reader.readEnum());
      msg.setPenaltyType(value);
      break;
    case 2:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.Penalty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.Penalty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.Penalty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.Penalty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPenaltyType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
};


/**
 * optional PenaltyType penalty_type = 1;
 * @return {!proto.buying.trivia.api.v1.PenaltyType}
 */
proto.buying.trivia.api.v1.Penalty.prototype.getPenaltyType = function() {
  return /** @type {!proto.buying.trivia.api.v1.PenaltyType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.trivia.api.v1.PenaltyType} value
 * @return {!proto.buying.trivia.api.v1.Penalty} returns this
 */
proto.buying.trivia.api.v1.Penalty.prototype.setPenaltyType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional google.protobuf.Duration duration = 2;
 * @return {?proto.google.protobuf.Duration}
 */
proto.buying.trivia.api.v1.Penalty.prototype.getDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 2));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.buying.trivia.api.v1.Penalty} returns this
*/
proto.buying.trivia.api.v1.Penalty.prototype.setDuration = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.Penalty} returns this
 */
proto.buying.trivia.api.v1.Penalty.prototype.clearDuration = function() {
  return this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.Penalty.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.Round.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.Round.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.Round} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.Round.toObject = function(includeInstance, msg) {
  var f, obj = {
currentRound: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalRounds: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.Round}
 */
proto.buying.trivia.api.v1.Round.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.Round;
  return proto.buying.trivia.api.v1.Round.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.Round} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.Round}
 */
proto.buying.trivia.api.v1.Round.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentRound(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalRounds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.Round.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.Round.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.Round} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.Round.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentRound();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalRounds();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 current_round = 1;
 * @return {number}
 */
proto.buying.trivia.api.v1.Round.prototype.getCurrentRound = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.Round} returns this
 */
proto.buying.trivia.api.v1.Round.prototype.setCurrentRound = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 total_rounds = 2;
 * @return {number}
 */
proto.buying.trivia.api.v1.Round.prototype.getTotalRounds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.Round} returns this
 */
proto.buying.trivia.api.v1.Round.prototype.setTotalRounds = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.Session.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.Session.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.Session.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.Session} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.Session.toObject = function(includeInstance, msg) {
  var f, obj = {
numberOfQuestionsAnswered: jspb.Message.getFieldWithDefault(msg, 1, 0),
numberOfQuestionsCorrect: jspb.Message.getFieldWithDefault(msg, 2, 0),
bonusQuestionUnlocked: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
answeredQuestionIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
sessionType: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.Session}
 */
proto.buying.trivia.api.v1.Session.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.Session;
  return proto.buying.trivia.api.v1.Session.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.Session} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.Session}
 */
proto.buying.trivia.api.v1.Session.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfQuestionsAnswered(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfQuestionsCorrect(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBonusQuestionUnlocked(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addAnsweredQuestionIds(value);
      break;
    case 5:
      var value = /** @type {!proto.buying.trivia.api.v1.SessionType} */ (reader.readEnum());
      msg.setSessionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.Session.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.Session.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.Session} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.Session.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumberOfQuestionsAnswered();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getNumberOfQuestionsCorrect();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBonusQuestionUnlocked();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getAnsweredQuestionIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getSessionType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional int32 number_of_questions_answered = 1;
 * @return {number}
 */
proto.buying.trivia.api.v1.Session.prototype.getNumberOfQuestionsAnswered = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.Session} returns this
 */
proto.buying.trivia.api.v1.Session.prototype.setNumberOfQuestionsAnswered = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 number_of_questions_correct = 2;
 * @return {number}
 */
proto.buying.trivia.api.v1.Session.prototype.getNumberOfQuestionsCorrect = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.Session} returns this
 */
proto.buying.trivia.api.v1.Session.prototype.setNumberOfQuestionsCorrect = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool bonus_question_unlocked = 3;
 * @return {boolean}
 */
proto.buying.trivia.api.v1.Session.prototype.getBonusQuestionUnlocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.trivia.api.v1.Session} returns this
 */
proto.buying.trivia.api.v1.Session.prototype.setBonusQuestionUnlocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated string answered_question_ids = 4;
 * @return {!Array<string>}
 */
proto.buying.trivia.api.v1.Session.prototype.getAnsweredQuestionIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.trivia.api.v1.Session} returns this
 */
proto.buying.trivia.api.v1.Session.prototype.setAnsweredQuestionIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.Session} returns this
 */
proto.buying.trivia.api.v1.Session.prototype.addAnsweredQuestionIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.Session} returns this
 */
proto.buying.trivia.api.v1.Session.prototype.clearAnsweredQuestionIdsList = function() {
  return this.setAnsweredQuestionIdsList([]);
};


/**
 * optional SessionType session_type = 5;
 * @return {!proto.buying.trivia.api.v1.SessionType}
 */
proto.buying.trivia.api.v1.Session.prototype.getSessionType = function() {
  return /** @type {!proto.buying.trivia.api.v1.SessionType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.buying.trivia.api.v1.SessionType} value
 * @return {!proto.buying.trivia.api.v1.Session} returns this
 */
proto.buying.trivia.api.v1.Session.prototype.setSessionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.CreateGameRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.CreateGameRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.CreateGameRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.CreateGameRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameConfig: (f = msg.getGameConfig()) && proto.buying.trivia.api.v1.GameConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.CreateGameRequest}
 */
proto.buying.trivia.api.v1.CreateGameRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.CreateGameRequest;
  return proto.buying.trivia.api.v1.CreateGameRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.CreateGameRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.CreateGameRequest}
 */
proto.buying.trivia.api.v1.CreateGameRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.trivia.api.v1.GameConfig;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.deserializeBinaryFromReader);
      msg.setGameConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.CreateGameRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.CreateGameRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.CreateGameRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.CreateGameRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameConfig();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.buying.trivia.api.v1.GameConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional GameConfig game_config = 1;
 * @return {?proto.buying.trivia.api.v1.GameConfig}
 */
proto.buying.trivia.api.v1.CreateGameRequest.prototype.getGameConfig = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig, 1));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig|undefined} value
 * @return {!proto.buying.trivia.api.v1.CreateGameRequest} returns this
*/
proto.buying.trivia.api.v1.CreateGameRequest.prototype.setGameConfig = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.CreateGameRequest} returns this
 */
proto.buying.trivia.api.v1.CreateGameRequest.prototype.clearGameConfig = function() {
  return this.setGameConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.CreateGameRequest.prototype.hasGameConfig = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.CreateGameResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.CreateGameResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.CreateGameResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.CreateGameResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, ""),
gameConfig: (f = msg.getGameConfig()) && proto.buying.trivia.api.v1.GameConfig.toObject(includeInstance, f),
version: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.CreateGameResponse}
 */
proto.buying.trivia.api.v1.CreateGameResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.CreateGameResponse;
  return proto.buying.trivia.api.v1.CreateGameResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.CreateGameResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.CreateGameResponse}
 */
proto.buying.trivia.api.v1.CreateGameResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    case 2:
      var value = new proto.buying.trivia.api.v1.GameConfig;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.deserializeBinaryFromReader);
      msg.setGameConfig(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.CreateGameResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.CreateGameResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.CreateGameResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.CreateGameResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGameConfig();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.buying.trivia.api.v1.GameConfig.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.CreateGameResponse.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.CreateGameResponse} returns this
 */
proto.buying.trivia.api.v1.CreateGameResponse.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional GameConfig game_config = 2;
 * @return {?proto.buying.trivia.api.v1.GameConfig}
 */
proto.buying.trivia.api.v1.CreateGameResponse.prototype.getGameConfig = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig, 2));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig|undefined} value
 * @return {!proto.buying.trivia.api.v1.CreateGameResponse} returns this
*/
proto.buying.trivia.api.v1.CreateGameResponse.prototype.setGameConfig = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.CreateGameResponse} returns this
 */
proto.buying.trivia.api.v1.CreateGameResponse.prototype.clearGameConfig = function() {
  return this.setGameConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.CreateGameResponse.prototype.hasGameConfig = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string version = 3;
 * @return {string}
 */
proto.buying.trivia.api.v1.CreateGameResponse.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.CreateGameResponse} returns this
 */
proto.buying.trivia.api.v1.CreateGameResponse.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.UpdateGameRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.UpdateGameRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.UpdateGameRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.UpdateGameRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, ""),
gameConfig: (f = msg.getGameConfig()) && proto.buying.trivia.api.v1.GameConfig.toObject(includeInstance, f),
version: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.UpdateGameRequest}
 */
proto.buying.trivia.api.v1.UpdateGameRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.UpdateGameRequest;
  return proto.buying.trivia.api.v1.UpdateGameRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.UpdateGameRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.UpdateGameRequest}
 */
proto.buying.trivia.api.v1.UpdateGameRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    case 2:
      var value = new proto.buying.trivia.api.v1.GameConfig;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.deserializeBinaryFromReader);
      msg.setGameConfig(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.UpdateGameRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.UpdateGameRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.UpdateGameRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.UpdateGameRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGameConfig();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.buying.trivia.api.v1.GameConfig.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.UpdateGameRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.UpdateGameRequest} returns this
 */
proto.buying.trivia.api.v1.UpdateGameRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional GameConfig game_config = 2;
 * @return {?proto.buying.trivia.api.v1.GameConfig}
 */
proto.buying.trivia.api.v1.UpdateGameRequest.prototype.getGameConfig = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig, 2));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig|undefined} value
 * @return {!proto.buying.trivia.api.v1.UpdateGameRequest} returns this
*/
proto.buying.trivia.api.v1.UpdateGameRequest.prototype.setGameConfig = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.UpdateGameRequest} returns this
 */
proto.buying.trivia.api.v1.UpdateGameRequest.prototype.clearGameConfig = function() {
  return this.setGameConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.UpdateGameRequest.prototype.hasGameConfig = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string version = 3;
 * @return {string}
 */
proto.buying.trivia.api.v1.UpdateGameRequest.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.UpdateGameRequest} returns this
 */
proto.buying.trivia.api.v1.UpdateGameRequest.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.UpdateGameResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.UpdateGameResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.UpdateGameResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.UpdateGameResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, ""),
gameConfig: (f = msg.getGameConfig()) && proto.buying.trivia.api.v1.GameConfig.toObject(includeInstance, f),
version: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.UpdateGameResponse}
 */
proto.buying.trivia.api.v1.UpdateGameResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.UpdateGameResponse;
  return proto.buying.trivia.api.v1.UpdateGameResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.UpdateGameResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.UpdateGameResponse}
 */
proto.buying.trivia.api.v1.UpdateGameResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    case 2:
      var value = new proto.buying.trivia.api.v1.GameConfig;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.deserializeBinaryFromReader);
      msg.setGameConfig(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.UpdateGameResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.UpdateGameResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.UpdateGameResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.UpdateGameResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGameConfig();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.buying.trivia.api.v1.GameConfig.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.UpdateGameResponse.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.UpdateGameResponse} returns this
 */
proto.buying.trivia.api.v1.UpdateGameResponse.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional GameConfig game_config = 2;
 * @return {?proto.buying.trivia.api.v1.GameConfig}
 */
proto.buying.trivia.api.v1.UpdateGameResponse.prototype.getGameConfig = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig, 2));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig|undefined} value
 * @return {!proto.buying.trivia.api.v1.UpdateGameResponse} returns this
*/
proto.buying.trivia.api.v1.UpdateGameResponse.prototype.setGameConfig = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.UpdateGameResponse} returns this
 */
proto.buying.trivia.api.v1.UpdateGameResponse.prototype.clearGameConfig = function() {
  return this.setGameConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.UpdateGameResponse.prototype.hasGameConfig = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string version = 3;
 * @return {string}
 */
proto.buying.trivia.api.v1.UpdateGameResponse.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.UpdateGameResponse} returns this
 */
proto.buying.trivia.api.v1.UpdateGameResponse.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.DeleteGameRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.DeleteGameRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.DeleteGameRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.DeleteGameRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.DeleteGameRequest}
 */
proto.buying.trivia.api.v1.DeleteGameRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.DeleteGameRequest;
  return proto.buying.trivia.api.v1.DeleteGameRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.DeleteGameRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.DeleteGameRequest}
 */
proto.buying.trivia.api.v1.DeleteGameRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.DeleteGameRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.DeleteGameRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.DeleteGameRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.DeleteGameRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.DeleteGameRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.DeleteGameRequest} returns this
 */
proto.buying.trivia.api.v1.DeleteGameRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.DeleteGameResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.DeleteGameResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.DeleteGameResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.DeleteGameResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.DeleteGameResponse}
 */
proto.buying.trivia.api.v1.DeleteGameResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.DeleteGameResponse;
  return proto.buying.trivia.api.v1.DeleteGameResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.DeleteGameResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.DeleteGameResponse}
 */
proto.buying.trivia.api.v1.DeleteGameResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.DeleteGameResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.DeleteGameResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.DeleteGameResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.DeleteGameResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetGameRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetGameRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetGameRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetGameRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetGameRequest}
 */
proto.buying.trivia.api.v1.GetGameRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetGameRequest;
  return proto.buying.trivia.api.v1.GetGameRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetGameRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetGameRequest}
 */
proto.buying.trivia.api.v1.GetGameRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetGameRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetGameRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetGameRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetGameRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetGameRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetGameRequest} returns this
 */
proto.buying.trivia.api.v1.GetGameRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetGameResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetGameResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetGameResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetGameResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
gameConfig: (f = msg.getGameConfig()) && proto.buying.trivia.api.v1.GameConfig.toObject(includeInstance, f),
version: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetGameResponse}
 */
proto.buying.trivia.api.v1.GetGameResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetGameResponse;
  return proto.buying.trivia.api.v1.GetGameResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetGameResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetGameResponse}
 */
proto.buying.trivia.api.v1.GetGameResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.trivia.api.v1.GameConfig;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.deserializeBinaryFromReader);
      msg.setGameConfig(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetGameResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetGameResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetGameResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetGameResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameConfig();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.buying.trivia.api.v1.GameConfig.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional GameConfig game_config = 1;
 * @return {?proto.buying.trivia.api.v1.GameConfig}
 */
proto.buying.trivia.api.v1.GetGameResponse.prototype.getGameConfig = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig, 1));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig|undefined} value
 * @return {!proto.buying.trivia.api.v1.GetGameResponse} returns this
*/
proto.buying.trivia.api.v1.GetGameResponse.prototype.setGameConfig = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GetGameResponse} returns this
 */
proto.buying.trivia.api.v1.GetGameResponse.prototype.clearGameConfig = function() {
  return this.setGameConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GetGameResponse.prototype.hasGameConfig = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string version = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetGameResponse.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetGameResponse} returns this
 */
proto.buying.trivia.api.v1.GetGameResponse.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GetTriviaGamesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetTriviaGamesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetTriviaGamesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetTriviaGamesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetTriviaGamesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetTriviaGamesRequest}
 */
proto.buying.trivia.api.v1.GetTriviaGamesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetTriviaGamesRequest;
  return proto.buying.trivia.api.v1.GetTriviaGamesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetTriviaGamesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetTriviaGamesRequest}
 */
proto.buying.trivia.api.v1.GetTriviaGamesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addGameIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetTriviaGamesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetTriviaGamesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetTriviaGamesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetTriviaGamesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string game_ids = 1;
 * @return {!Array<string>}
 */
proto.buying.trivia.api.v1.GetTriviaGamesRequest.prototype.getGameIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaGamesRequest} returns this
 */
proto.buying.trivia.api.v1.GetTriviaGamesRequest.prototype.setGameIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.GetTriviaGamesRequest} returns this
 */
proto.buying.trivia.api.v1.GetTriviaGamesRequest.prototype.addGameIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetTriviaGamesRequest} returns this
 */
proto.buying.trivia.api.v1.GetTriviaGamesRequest.prototype.clearGameIdsList = function() {
  return this.setGameIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GetTriviaGamesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetTriviaGamesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetTriviaGamesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetTriviaGamesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetTriviaGamesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
gamesList: jspb.Message.toObjectList(msg.getGamesList(),
    proto.buying.trivia.api.v1.Game.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetTriviaGamesResponse}
 */
proto.buying.trivia.api.v1.GetTriviaGamesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetTriviaGamesResponse;
  return proto.buying.trivia.api.v1.GetTriviaGamesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetTriviaGamesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetTriviaGamesResponse}
 */
proto.buying.trivia.api.v1.GetTriviaGamesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.trivia.api.v1.Game;
      reader.readMessage(value,proto.buying.trivia.api.v1.Game.deserializeBinaryFromReader);
      msg.addGames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetTriviaGamesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetTriviaGamesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetTriviaGamesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetTriviaGamesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGamesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.trivia.api.v1.Game.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Game games = 1;
 * @return {!Array<!proto.buying.trivia.api.v1.Game>}
 */
proto.buying.trivia.api.v1.GetTriviaGamesResponse.prototype.getGamesList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.Game>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.Game, 1));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.Game>} value
 * @return {!proto.buying.trivia.api.v1.GetTriviaGamesResponse} returns this
*/
proto.buying.trivia.api.v1.GetTriviaGamesResponse.prototype.setGamesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.Game=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.Game}
 */
proto.buying.trivia.api.v1.GetTriviaGamesResponse.prototype.addGames = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.trivia.api.v1.Game, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetTriviaGamesResponse} returns this
 */
proto.buying.trivia.api.v1.GetTriviaGamesResponse.prototype.clearGamesList = function() {
  return this.setGamesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest}
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest;
  return proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest}
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addGameIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string game_ids = 1;
 * @return {!Array<string>}
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.prototype.getGameIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest} returns this
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.prototype.setGameIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest} returns this
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.prototype.addGameIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest} returns this
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesRequest.prototype.clearGameIdsList = function() {
  return this.setGameIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
gamesList: jspb.Message.toObjectList(msg.getGamesList(),
    proto.buying.trivia.api.v1.RedactedGameConfig.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse}
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse;
  return proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse}
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.trivia.api.v1.RedactedGameConfig;
      reader.readMessage(value,proto.buying.trivia.api.v1.RedactedGameConfig.deserializeBinaryFromReader);
      msg.addGames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGamesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.trivia.api.v1.RedactedGameConfig.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RedactedGameConfig games = 1;
 * @return {!Array<!proto.buying.trivia.api.v1.RedactedGameConfig>}
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.prototype.getGamesList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.RedactedGameConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.RedactedGameConfig, 1));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.RedactedGameConfig>} value
 * @return {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse} returns this
*/
proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.prototype.setGamesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.RedactedGameConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig}
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.prototype.addGames = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.trivia.api.v1.RedactedGameConfig, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse} returns this
 */
proto.buying.trivia.api.v1.GetRedactedTriviaGamesResponse.prototype.clearGamesList = function() {
  return this.setGamesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.ClearRankingsCacheRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.ClearRankingsCacheRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.ClearRankingsCacheRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.ClearRankingsCacheRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.ClearRankingsCacheRequest}
 */
proto.buying.trivia.api.v1.ClearRankingsCacheRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.ClearRankingsCacheRequest;
  return proto.buying.trivia.api.v1.ClearRankingsCacheRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.ClearRankingsCacheRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.ClearRankingsCacheRequest}
 */
proto.buying.trivia.api.v1.ClearRankingsCacheRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.ClearRankingsCacheRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.ClearRankingsCacheRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.ClearRankingsCacheRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.ClearRankingsCacheRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string game_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.ClearRankingsCacheRequest.prototype.getGameId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.ClearRankingsCacheRequest} returns this
 */
proto.buying.trivia.api.v1.ClearRankingsCacheRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.ClearRankingsCacheResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.ClearRankingsCacheResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.ClearRankingsCacheResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.ClearRankingsCacheResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.ClearRankingsCacheResponse}
 */
proto.buying.trivia.api.v1.ClearRankingsCacheResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.ClearRankingsCacheResponse;
  return proto.buying.trivia.api.v1.ClearRankingsCacheResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.ClearRankingsCacheResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.ClearRankingsCacheResponse}
 */
proto.buying.trivia.api.v1.ClearRankingsCacheResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.ClearRankingsCacheResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.ClearRankingsCacheResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.ClearRankingsCacheResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.ClearRankingsCacheResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetCurrentHostRankingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetCurrentHostRankingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetCurrentHostRankingRequest}
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetCurrentHostRankingRequest;
  return proto.buying.trivia.api.v1.GetCurrentHostRankingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetCurrentHostRankingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetCurrentHostRankingRequest}
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetCurrentHostRankingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetCurrentHostRankingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetCurrentHostRankingRequest} returns this
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GetCurrentHostRankingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GetCurrentHostRankingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
rank: jspb.Message.getFieldWithDefault(msg, 1, 0),
host: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GetCurrentHostRankingResponse}
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GetCurrentHostRankingResponse;
  return proto.buying.trivia.api.v1.GetCurrentHostRankingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GetCurrentHostRankingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GetCurrentHostRankingResponse}
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GetCurrentHostRankingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GetCurrentHostRankingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 rank = 1;
 * @return {number}
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingResponse.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GetCurrentHostRankingResponse} returns this
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingResponse.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string host = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingResponse.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GetCurrentHostRankingResponse} returns this
 */
proto.buying.trivia.api.v1.GetCurrentHostRankingResponse.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GameConfig.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GameConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GameConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
host: jspb.Message.getFieldWithDefault(msg, 2, ""),
theme: jspb.Message.getFieldWithDefault(msg, 3, ""),
entryTime: (f = msg.getEntryTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
isPublished: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
primaryQuestionsList: jspb.Message.toObjectList(msg.getPrimaryQuestionsList(),
    proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.toObject, includeInstance),
bonusQuestion: (f = msg.getBonusQuestion()) && proto.buying.trivia.api.v1.GameConfig.BonusQuestion.toObject(includeInstance, f),
playingPeriod: (f = msg.getPlayingPeriod()) && proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.toObject(includeInstance, f),
minimumAnsweredCorrectlyForAccessToBonusQuestion: jspb.Message.getFieldWithDefault(msg, 9, 0),
numberOfQuestionsAnsweredCorrectlyForAStreak: jspb.Message.getFieldWithDefault(msg, 10, 0),
gameImageAssets: (f = msg.getGameImageAssets()) && proto.buying.trivia.api.v1.GameConfig.GameImageAssets.toObject(includeInstance, f),
nonLiveDuration: (f = msg.getNonLiveDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
lobbyAsset: (f = msg.getLobbyAsset()) && proto.buying.trivia.api.v1.GameConfig.Asset.toObject(includeInstance, f),
scheduleAsset: (f = msg.getScheduleAsset()) && proto.buying.trivia.api.v1.GameConfig.Asset.toObject(includeInstance, f),
lobbyAudioAsset: (f = msg.getLobbyAudioAsset()) && proto.buying.trivia.api.v1.GameConfig.Asset.toObject(includeInstance, f),
liveHowToAsset: (f = msg.getLiveHowToAsset()) && proto.buying.trivia.api.v1.GameConfig.Asset.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GameConfig}
 */
proto.buying.trivia.api.v1.GameConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GameConfig;
  return proto.buying.trivia.api.v1.GameConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GameConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GameConfig}
 */
proto.buying.trivia.api.v1.GameConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTheme(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEntryTime(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPublished(value);
      break;
    case 6:
      var value = new proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.deserializeBinaryFromReader);
      msg.addPrimaryQuestions(value);
      break;
    case 7:
      var value = new proto.buying.trivia.api.v1.GameConfig.BonusQuestion;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.BonusQuestion.deserializeBinaryFromReader);
      msg.setBonusQuestion(value);
      break;
    case 8:
      var value = new proto.buying.trivia.api.v1.GameConfig.PlayingPeriod;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.deserializeBinaryFromReader);
      msg.setPlayingPeriod(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinimumAnsweredCorrectlyForAccessToBonusQuestion(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfQuestionsAnsweredCorrectlyForAStreak(value);
      break;
    case 11:
      var value = new proto.buying.trivia.api.v1.GameConfig.GameImageAssets;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.GameImageAssets.deserializeBinaryFromReader);
      msg.setGameImageAssets(value);
      break;
    case 12:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setNonLiveDuration(value);
      break;
    case 13:
      var value = new proto.buying.trivia.api.v1.GameConfig.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.Asset.deserializeBinaryFromReader);
      msg.setLobbyAsset(value);
      break;
    case 14:
      var value = new proto.buying.trivia.api.v1.GameConfig.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.Asset.deserializeBinaryFromReader);
      msg.setScheduleAsset(value);
      break;
    case 15:
      var value = new proto.buying.trivia.api.v1.GameConfig.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.Asset.deserializeBinaryFromReader);
      msg.setLobbyAudioAsset(value);
      break;
    case 16:
      var value = new proto.buying.trivia.api.v1.GameConfig.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.Asset.deserializeBinaryFromReader);
      msg.setLiveHowToAsset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GameConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GameConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTheme();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEntryTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsPublished();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getPrimaryQuestionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.serializeBinaryToWriter
    );
  }
  f = message.getBonusQuestion();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.buying.trivia.api.v1.GameConfig.BonusQuestion.serializeBinaryToWriter
    );
  }
  f = message.getPlayingPeriod();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.serializeBinaryToWriter
    );
  }
  f = message.getMinimumAnsweredCorrectlyForAccessToBonusQuestion();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getNumberOfQuestionsAnsweredCorrectlyForAStreak();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getGameImageAssets();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.buying.trivia.api.v1.GameConfig.GameImageAssets.serializeBinaryToWriter
    );
  }
  f = message.getNonLiveDuration();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getLobbyAsset();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.buying.trivia.api.v1.GameConfig.Asset.serializeBinaryToWriter
    );
  }
  f = message.getScheduleAsset();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.buying.trivia.api.v1.GameConfig.Asset.serializeBinaryToWriter
    );
  }
  f = message.getLobbyAudioAsset();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.buying.trivia.api.v1.GameConfig.Asset.serializeBinaryToWriter
    );
  }
  f = message.getLiveHowToAsset();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.buying.trivia.api.v1.GameConfig.Asset.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.buying.trivia.api.v1.GameConfig.AssetType = {
  GAME_CONFIG_ASSET_TYPE_INVALID: 0,
  GAME_CONFIG_ASSET_TYPE_IMAGE: 1,
  GAME_CONFIG_ASSET_TYPE_VIDEO: 2,
  GAME_CONFIG_ASSET_TYPE_AUDIO: 3
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.toObject = function(includeInstance, msg) {
  var f, obj = {
questionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
questionType: jspb.Message.getFieldWithDefault(msg, 2, 0),
questionAsset: (f = msg.getQuestionAsset()) && proto.buying.trivia.api.v1.GameConfig.Asset.toObject(includeInstance, f),
questionText: jspb.Message.getFieldWithDefault(msg, 4, ""),
multipleChoiceAnswersList: jspb.Message.toObjectList(msg.getMultipleChoiceAnswersList(),
    proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.toObject, includeInstance),
correctTrueFalseAnswer: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
isEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion;
  return proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    case 2:
      var value = /** @type {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.QuestionType} */ (reader.readEnum());
      msg.setQuestionType(value);
      break;
    case 3:
      var value = new proto.buying.trivia.api.v1.GameConfig.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.Asset.deserializeBinaryFromReader);
      msg.setQuestionAsset(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionText(value);
      break;
    case 5:
      var value = new proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.deserializeBinaryFromReader);
      msg.addMultipleChoiceAnswers(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCorrectTrueFalseAnswer(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getQuestionAsset();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.buying.trivia.api.v1.GameConfig.Asset.serializeBinaryToWriter
    );
  }
  f = message.getQuestionText();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMultipleChoiceAnswersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.serializeBinaryToWriter
    );
  }
  f = message.getCorrectTrueFalseAnswer();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIsEnabled();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.QuestionType = {
  GAME_CONFIG_PRIMARY_QUESTION_QUESTION_TYPE_INVALID: 0,
  GAME_CONFIG_PRIMARY_QUESTION_QUESTION_TYPE_MULTIPLE_CHOICE: 1,
  GAME_CONFIG_PRIMARY_QUESTION_QUESTION_TYPE_TRUE_FALSE: 2,
  GAME_CONFIG_PRIMARY_QUESTION_QUESTION_TYPE_MULTIPLE_CHOICE_WITH_ANSWER_ASSETS: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.toObject = function(includeInstance, msg) {
  var f, obj = {
answerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
answerText: jspb.Message.getFieldWithDefault(msg, 2, ""),
isCorrect: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
answerAsset: (f = msg.getAnswerAsset()) && proto.buying.trivia.api.v1.GameConfig.Asset.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer;
  return proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerText(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCorrect(value);
      break;
    case 4:
      var value = new proto.buying.trivia.api.v1.GameConfig.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.Asset.deserializeBinaryFromReader);
      msg.setAnswerAsset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnswerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAnswerText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsCorrect();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getAnswerAsset();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.buying.trivia.api.v1.GameConfig.Asset.serializeBinaryToWriter
    );
  }
};


/**
 * optional string answer_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.prototype.getAnswerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.prototype.setAnswerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string answer_text = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.prototype.getAnswerText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.prototype.setAnswerText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_correct = 3;
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.prototype.getIsCorrect = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.prototype.setIsCorrect = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional Asset answer_asset = 4;
 * @return {?proto.buying.trivia.api.v1.GameConfig.Asset}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.prototype.getAnswerAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig.Asset, 4));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer} returns this
*/
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.prototype.setAnswerAsset = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.prototype.clearAnswerAsset = function() {
  return this.setAnswerAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer.prototype.hasAnswerAsset = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string question_id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional QuestionType question_type = 2;
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.QuestionType}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.getQuestionType = function() {
  return /** @type {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.QuestionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.QuestionType} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.setQuestionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Asset question_asset = 3;
 * @return {?proto.buying.trivia.api.v1.GameConfig.Asset}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.getQuestionAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig.Asset, 3));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion} returns this
*/
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.setQuestionAsset = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.clearQuestionAsset = function() {
  return this.setQuestionAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.hasQuestionAsset = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string question_text = 4;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.getQuestionText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.setQuestionText = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated MultipleChoiceAnswer multiple_choice_answers = 5;
 * @return {!Array<!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer>}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.getMultipleChoiceAnswersList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer, 5));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer>} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion} returns this
*/
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.setMultipleChoiceAnswersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.addMultipleChoiceAnswers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.MultipleChoiceAnswer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.clearMultipleChoiceAnswersList = function() {
  return this.setMultipleChoiceAnswersList([]);
};


/**
 * optional bool correct_true_false_answer = 6;
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.getCorrectTrueFalseAnswer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.setCorrectTrueFalseAnswer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool is_enabled = 7;
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.getIsEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion.prototype.setIsEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GameConfig.GameImageAssets.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GameConfig.GameImageAssets.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GameConfig.GameImageAssets} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.GameImageAssets.toObject = function(includeInstance, msg) {
  var f, obj = {
lobbyBackgroundUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GameConfig.GameImageAssets}
 */
proto.buying.trivia.api.v1.GameConfig.GameImageAssets.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GameConfig.GameImageAssets;
  return proto.buying.trivia.api.v1.GameConfig.GameImageAssets.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GameConfig.GameImageAssets} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GameConfig.GameImageAssets}
 */
proto.buying.trivia.api.v1.GameConfig.GameImageAssets.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLobbyBackgroundUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GameConfig.GameImageAssets.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GameConfig.GameImageAssets.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GameConfig.GameImageAssets} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.GameImageAssets.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLobbyBackgroundUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string lobby_background_url = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameConfig.GameImageAssets.prototype.getLobbyBackgroundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.GameImageAssets} returns this
 */
proto.buying.trivia.api.v1.GameConfig.GameImageAssets.prototype.setLobbyBackgroundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.repeatedFields_ = [4,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GameConfig.BonusQuestion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GameConfig.BonusQuestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.toObject = function(includeInstance, msg) {
  var f, obj = {
questionText: jspb.Message.getFieldWithDefault(msg, 1, ""),
maxItemsCorrect: jspb.Message.getFieldWithDefault(msg, 2, 0),
spaceGroupId: jspb.Message.getFieldWithDefault(msg, 3, ""),
correctProductTemplateIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
shareDescription: jspb.Message.getFieldWithDefault(msg, 5, ""),
correctProductTemplateGroupsList: jspb.Message.toObjectList(msg.getCorrectProductTemplateGroupsList(),
    proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GameConfig.BonusQuestion}
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GameConfig.BonusQuestion;
  return proto.buying.trivia.api.v1.GameConfig.BonusQuestion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GameConfig.BonusQuestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GameConfig.BonusQuestion}
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionText(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxItemsCorrect(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSpaceGroupId(value);
      break;
    case 4:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCorrectProductTemplateIds(values[i]);
      }
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareDescription(value);
      break;
    case 6:
      var value = new proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.deserializeBinaryFromReader);
      msg.addCorrectProductTemplateGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GameConfig.BonusQuestion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GameConfig.BonusQuestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMaxItemsCorrect();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSpaceGroupId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCorrectProductTemplateIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      4,
      f
    );
  }
  f = message.getShareDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCorrectProductTemplateGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional string question_text = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.getQuestionText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.BonusQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.setQuestionText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 max_items_correct = 2;
 * @return {number}
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.getMaxItemsCorrect = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.BonusQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.setMaxItemsCorrect = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string space_group_id = 3;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.getSpaceGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.BonusQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.setSpaceGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated int32 correct_product_template_ids = 4;
 * @return {!Array<number>}
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.getCorrectProductTemplateIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.BonusQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.setCorrectProductTemplateIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.GameConfig.BonusQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.addCorrectProductTemplateIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GameConfig.BonusQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.clearCorrectProductTemplateIdsList = function() {
  return this.setCorrectProductTemplateIdsList([]);
};


/**
 * optional string share_description = 5;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.getShareDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.BonusQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.setShareDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated ProductTemplateGroup correct_product_template_groups = 6;
 * @return {!Array<!proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup>}
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.getCorrectProductTemplateGroupsList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup, 6));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup>} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.BonusQuestion} returns this
*/
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.setCorrectProductTemplateGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup}
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.addCorrectProductTemplateGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GameConfig.BonusQuestion} returns this
 */
proto.buying.trivia.api.v1.GameConfig.BonusQuestion.prototype.clearCorrectProductTemplateGroupsList = function() {
  return this.setCorrectProductTemplateGroupsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup}
 */
proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup;
  return proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup}
 */
proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 ids = 1;
 * @return {!Array<number>}
 */
proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.prototype.getIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup} returns this
 */
proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup} returns this
 */
proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup} returns this
 */
proto.buying.trivia.api.v1.GameConfig.ProductTemplateGroup.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GameConfig.PlayingPeriod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.toObject = function(includeInstance, msg) {
  var f, obj = {
liveStartTimeInclusiveBound: (f = msg.getLiveStartTimeInclusiveBound()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
liveLastEntryTimeInclusiveBound: (f = msg.getLiveLastEntryTimeInclusiveBound()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
liveEndTimeExclusiveBound: (f = msg.getLiveEndTimeExclusiveBound()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
nonLiveEndTimeExclusiveBound: (f = msg.getNonLiveEndTimeExclusiveBound()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GameConfig.PlayingPeriod}
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GameConfig.PlayingPeriod;
  return proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GameConfig.PlayingPeriod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GameConfig.PlayingPeriod}
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLiveStartTimeInclusiveBound(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLiveLastEntryTimeInclusiveBound(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLiveEndTimeExclusiveBound(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNonLiveEndTimeExclusiveBound(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GameConfig.PlayingPeriod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLiveStartTimeInclusiveBound();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLiveLastEntryTimeInclusiveBound();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLiveEndTimeExclusiveBound();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNonLiveEndTimeExclusiveBound();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp live_start_time_inclusive_bound = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.getLiveStartTimeInclusiveBound = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PlayingPeriod} returns this
*/
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.setLiveStartTimeInclusiveBound = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig.PlayingPeriod} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.clearLiveStartTimeInclusiveBound = function() {
  return this.setLiveStartTimeInclusiveBound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.hasLiveStartTimeInclusiveBound = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp live_last_entry_time_inclusive_bound = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.getLiveLastEntryTimeInclusiveBound = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PlayingPeriod} returns this
*/
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.setLiveLastEntryTimeInclusiveBound = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig.PlayingPeriod} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.clearLiveLastEntryTimeInclusiveBound = function() {
  return this.setLiveLastEntryTimeInclusiveBound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.hasLiveLastEntryTimeInclusiveBound = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp live_end_time_exclusive_bound = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.getLiveEndTimeExclusiveBound = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PlayingPeriod} returns this
*/
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.setLiveEndTimeExclusiveBound = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig.PlayingPeriod} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.clearLiveEndTimeExclusiveBound = function() {
  return this.setLiveEndTimeExclusiveBound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.hasLiveEndTimeExclusiveBound = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp non_live_end_time_exclusive_bound = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.getNonLiveEndTimeExclusiveBound = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.PlayingPeriod} returns this
*/
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.setNonLiveEndTimeExclusiveBound = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig.PlayingPeriod} returns this
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.clearNonLiveEndTimeExclusiveBound = function() {
  return this.setNonLiveEndTimeExclusiveBound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.PlayingPeriod.prototype.hasNonLiveEndTimeExclusiveBound = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.GameConfig.Asset.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.GameConfig.Asset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.GameConfig.Asset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.Asset.toObject = function(includeInstance, msg) {
  var f, obj = {
assetType: jspb.Message.getFieldWithDefault(msg, 1, 0),
url: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.GameConfig.Asset}
 */
proto.buying.trivia.api.v1.GameConfig.Asset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.GameConfig.Asset;
  return proto.buying.trivia.api.v1.GameConfig.Asset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.GameConfig.Asset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.GameConfig.Asset}
 */
proto.buying.trivia.api.v1.GameConfig.Asset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.trivia.api.v1.GameConfig.AssetType} */ (reader.readEnum());
      msg.setAssetType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.GameConfig.Asset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.GameConfig.Asset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.GameConfig.Asset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.GameConfig.Asset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssetType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional AssetType asset_type = 1;
 * @return {!proto.buying.trivia.api.v1.GameConfig.AssetType}
 */
proto.buying.trivia.api.v1.GameConfig.Asset.prototype.getAssetType = function() {
  return /** @type {!proto.buying.trivia.api.v1.GameConfig.AssetType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.trivia.api.v1.GameConfig.AssetType} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.Asset} returns this
 */
proto.buying.trivia.api.v1.GameConfig.Asset.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameConfig.Asset.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameConfig.Asset} returns this
 */
proto.buying.trivia.api.v1.GameConfig.Asset.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string host = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string theme = 3;
 * @return {string}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getTheme = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.setTheme = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp entry_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getEntryTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
*/
proto.buying.trivia.api.v1.GameConfig.prototype.setEntryTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.clearEntryTime = function() {
  return this.setEntryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.hasEntryTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool is_published = 5;
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getIsPublished = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.setIsPublished = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated PrimaryQuestion primary_questions = 6;
 * @return {!Array<!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion>}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getPrimaryQuestionsList = function() {
  return /** @type{!Array<!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion, 6));
};


/**
 * @param {!Array<!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion>} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
*/
proto.buying.trivia.api.v1.GameConfig.prototype.setPrimaryQuestionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.addPrimaryQuestions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.buying.trivia.api.v1.GameConfig.PrimaryQuestion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.clearPrimaryQuestionsList = function() {
  return this.setPrimaryQuestionsList([]);
};


/**
 * optional BonusQuestion bonus_question = 7;
 * @return {?proto.buying.trivia.api.v1.GameConfig.BonusQuestion}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getBonusQuestion = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig.BonusQuestion} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig.BonusQuestion, 7));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig.BonusQuestion|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
*/
proto.buying.trivia.api.v1.GameConfig.prototype.setBonusQuestion = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.clearBonusQuestion = function() {
  return this.setBonusQuestion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.hasBonusQuestion = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional PlayingPeriod playing_period = 8;
 * @return {?proto.buying.trivia.api.v1.GameConfig.PlayingPeriod}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getPlayingPeriod = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig.PlayingPeriod} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig.PlayingPeriod, 8));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig.PlayingPeriod|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
*/
proto.buying.trivia.api.v1.GameConfig.prototype.setPlayingPeriod = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.clearPlayingPeriod = function() {
  return this.setPlayingPeriod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.hasPlayingPeriod = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 minimum_answered_correctly_for_access_to_bonus_question = 9;
 * @return {number}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getMinimumAnsweredCorrectlyForAccessToBonusQuestion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.setMinimumAnsweredCorrectlyForAccessToBonusQuestion = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 number_of_questions_answered_correctly_for_a_streak = 10;
 * @return {number}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getNumberOfQuestionsAnsweredCorrectlyForAStreak = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.setNumberOfQuestionsAnsweredCorrectlyForAStreak = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional GameImageAssets game_image_assets = 11;
 * @return {?proto.buying.trivia.api.v1.GameConfig.GameImageAssets}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getGameImageAssets = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig.GameImageAssets} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig.GameImageAssets, 11));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig.GameImageAssets|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
*/
proto.buying.trivia.api.v1.GameConfig.prototype.setGameImageAssets = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.clearGameImageAssets = function() {
  return this.setGameImageAssets(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.hasGameImageAssets = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Duration non_live_duration = 12;
 * @return {?proto.google.protobuf.Duration}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getNonLiveDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 12));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
*/
proto.buying.trivia.api.v1.GameConfig.prototype.setNonLiveDuration = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.clearNonLiveDuration = function() {
  return this.setNonLiveDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.hasNonLiveDuration = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional Asset lobby_asset = 13;
 * @return {?proto.buying.trivia.api.v1.GameConfig.Asset}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getLobbyAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig.Asset, 13));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
*/
proto.buying.trivia.api.v1.GameConfig.prototype.setLobbyAsset = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.clearLobbyAsset = function() {
  return this.setLobbyAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.hasLobbyAsset = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional Asset schedule_asset = 14;
 * @return {?proto.buying.trivia.api.v1.GameConfig.Asset}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getScheduleAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig.Asset, 14));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
*/
proto.buying.trivia.api.v1.GameConfig.prototype.setScheduleAsset = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.clearScheduleAsset = function() {
  return this.setScheduleAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.hasScheduleAsset = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional Asset lobby_audio_asset = 15;
 * @return {?proto.buying.trivia.api.v1.GameConfig.Asset}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getLobbyAudioAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig.Asset, 15));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
*/
proto.buying.trivia.api.v1.GameConfig.prototype.setLobbyAudioAsset = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.clearLobbyAudioAsset = function() {
  return this.setLobbyAudioAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.hasLobbyAudioAsset = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional Asset live_how_to_asset = 16;
 * @return {?proto.buying.trivia.api.v1.GameConfig.Asset}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.getLiveHowToAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig.Asset, 16));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
*/
proto.buying.trivia.api.v1.GameConfig.prototype.setLiveHowToAsset = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.GameConfig} returns this
 */
proto.buying.trivia.api.v1.GameConfig.prototype.clearLiveHowToAsset = function() {
  return this.setLiveHowToAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.GameConfig.prototype.hasLiveHowToAsset = function() {
  return jspb.Message.getField(this, 16) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.Game.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.Game.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.Game} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.Game.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
config: (f = msg.getConfig()) && proto.buying.trivia.api.v1.GameConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.Game}
 */
proto.buying.trivia.api.v1.Game.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.Game;
  return proto.buying.trivia.api.v1.Game.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.Game} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.Game}
 */
proto.buying.trivia.api.v1.Game.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.buying.trivia.api.v1.GameConfig;
      reader.readMessage(value,proto.buying.trivia.api.v1.GameConfig.deserializeBinaryFromReader);
      msg.setConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.Game.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.Game.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.Game} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.Game.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfig();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.buying.trivia.api.v1.GameConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.Game.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.Game} returns this
 */
proto.buying.trivia.api.v1.Game.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional GameConfig config = 2;
 * @return {?proto.buying.trivia.api.v1.GameConfig}
 */
proto.buying.trivia.api.v1.Game.prototype.getConfig = function() {
  return /** @type{?proto.buying.trivia.api.v1.GameConfig} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.GameConfig, 2));
};


/**
 * @param {?proto.buying.trivia.api.v1.GameConfig|undefined} value
 * @return {!proto.buying.trivia.api.v1.Game} returns this
*/
proto.buying.trivia.api.v1.Game.prototype.setConfig = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.Game} returns this
 */
proto.buying.trivia.api.v1.Game.prototype.clearConfig = function() {
  return this.setConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.Game.prototype.hasConfig = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.trivia.api.v1.RedactedGameConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.trivia.api.v1.RedactedGameConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.RedactedGameConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
host: jspb.Message.getFieldWithDefault(msg, 3, ""),
theme: jspb.Message.getFieldWithDefault(msg, 4, ""),
isPublished: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
liveStartTimeInclusiveBound: (f = msg.getLiveStartTimeInclusiveBound()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
liveEndTimeExclusiveBound: (f = msg.getLiveEndTimeExclusiveBound()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
nonLiveDuration: (f = msg.getNonLiveDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
nonLiveEndTimeExclusiveBound: (f = msg.getNonLiveEndTimeExclusiveBound()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
lobbyAsset: (f = msg.getLobbyAsset()) && proto.buying.trivia.api.v1.Asset.toObject(includeInstance, f),
scheduleAsset: (f = msg.getScheduleAsset()) && proto.buying.trivia.api.v1.Asset.toObject(includeInstance, f),
played: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
liveHowToAsset: (f = msg.getLiveHowToAsset()) && proto.buying.trivia.api.v1.Asset.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.trivia.api.v1.RedactedGameConfig;
  return proto.buying.trivia.api.v1.RedactedGameConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.trivia.api.v1.RedactedGameConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTheme(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPublished(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLiveStartTimeInclusiveBound(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLiveEndTimeExclusiveBound(value);
      break;
    case 8:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setNonLiveDuration(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNonLiveEndTimeExclusiveBound(value);
      break;
    case 10:
      var value = new proto.buying.trivia.api.v1.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.Asset.deserializeBinaryFromReader);
      msg.setLobbyAsset(value);
      break;
    case 11:
      var value = new proto.buying.trivia.api.v1.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.Asset.deserializeBinaryFromReader);
      msg.setScheduleAsset(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlayed(value);
      break;
    case 13:
      var value = new proto.buying.trivia.api.v1.Asset;
      reader.readMessage(value,proto.buying.trivia.api.v1.Asset.deserializeBinaryFromReader);
      msg.setLiveHowToAsset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.trivia.api.v1.RedactedGameConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.trivia.api.v1.RedactedGameConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.trivia.api.v1.RedactedGameConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTheme();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIsPublished();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getLiveStartTimeInclusiveBound();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLiveEndTimeExclusiveBound();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNonLiveDuration();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getNonLiveEndTimeExclusiveBound();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLobbyAsset();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.buying.trivia.api.v1.Asset.serializeBinaryToWriter
    );
  }
  f = message.getScheduleAsset();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.buying.trivia.api.v1.Asset.serializeBinaryToWriter
    );
  }
  f = message.getPlayed();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getLiveHowToAsset();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.buying.trivia.api.v1.Asset.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string host = 3;
 * @return {string}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string theme = 4;
 * @return {string}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.getTheme = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.setTheme = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool is_published = 5;
 * @return {boolean}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.getIsPublished = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.setIsPublished = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp live_start_time_inclusive_bound = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.getLiveStartTimeInclusiveBound = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
*/
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.setLiveStartTimeInclusiveBound = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.clearLiveStartTimeInclusiveBound = function() {
  return this.setLiveStartTimeInclusiveBound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.hasLiveStartTimeInclusiveBound = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp live_end_time_exclusive_bound = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.getLiveEndTimeExclusiveBound = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
*/
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.setLiveEndTimeExclusiveBound = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.clearLiveEndTimeExclusiveBound = function() {
  return this.setLiveEndTimeExclusiveBound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.hasLiveEndTimeExclusiveBound = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Duration non_live_duration = 8;
 * @return {?proto.google.protobuf.Duration}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.getNonLiveDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 8));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
*/
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.setNonLiveDuration = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.clearNonLiveDuration = function() {
  return this.setNonLiveDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.hasNonLiveDuration = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp non_live_end_time_exclusive_bound = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.getNonLiveEndTimeExclusiveBound = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
*/
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.setNonLiveEndTimeExclusiveBound = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.clearNonLiveEndTimeExclusiveBound = function() {
  return this.setNonLiveEndTimeExclusiveBound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.hasNonLiveEndTimeExclusiveBound = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Asset lobby_asset = 10;
 * @return {?proto.buying.trivia.api.v1.Asset}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.getLobbyAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Asset, 10));
};


/**
 * @param {?proto.buying.trivia.api.v1.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
*/
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.setLobbyAsset = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.clearLobbyAsset = function() {
  return this.setLobbyAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.hasLobbyAsset = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Asset schedule_asset = 11;
 * @return {?proto.buying.trivia.api.v1.Asset}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.getScheduleAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Asset, 11));
};


/**
 * @param {?proto.buying.trivia.api.v1.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
*/
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.setScheduleAsset = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.clearScheduleAsset = function() {
  return this.setScheduleAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.hasScheduleAsset = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional bool played = 12;
 * @return {boolean}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.getPlayed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.setPlayed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional Asset live_how_to_asset = 13;
 * @return {?proto.buying.trivia.api.v1.Asset}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.getLiveHowToAsset = function() {
  return /** @type{?proto.buying.trivia.api.v1.Asset} */ (
    jspb.Message.getWrapperField(this, proto.buying.trivia.api.v1.Asset, 13));
};


/**
 * @param {?proto.buying.trivia.api.v1.Asset|undefined} value
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
*/
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.setLiveHowToAsset = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.trivia.api.v1.RedactedGameConfig} returns this
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.clearLiveHowToAsset = function() {
  return this.setLiveHowToAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.trivia.api.v1.RedactedGameConfig.prototype.hasLiveHowToAsset = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * @enum {number}
 */
proto.buying.trivia.api.v1.RankingsType = {
  RANKINGS_TYPE_INVALID: 0,
  RANKINGS_TYPE_TOTAL: 1,
  RANKINGS_TYPE_DAILY: 2
};

/**
 * @enum {number}
 */
proto.buying.trivia.api.v1.AssetType = {
  ASSET_TYPE_INVALID: 0,
  ASSET_TYPE_IMAGE: 1,
  ASSET_TYPE_VIDEO: 2,
  ASSET_TYPE_AUDIO: 3
};

/**
 * @enum {number}
 */
proto.buying.trivia.api.v1.Direction = {
  DIRECTION_INVALID: 0,
  DIRECTION_UP: 1,
  DIRECTION_DOWN: 2,
  DIRECTION_SAME: 3
};

/**
 * @enum {number}
 */
proto.buying.trivia.api.v1.PenaltyType = {
  PENALTY_TYPE_INVALID: 0,
  PENALTY_TYPE_INCORRECT: 1,
  PENALTY_TYPE_DELAYED_START: 2
};

/**
 * @enum {number}
 */
proto.buying.trivia.api.v1.SessionType = {
  SESSION_TYPE_INVALID: 0,
  SESSION_TYPE_LIVE: 1,
  SESSION_TYPE_NON_LIVE: 2
};

/**
 * @enum {number}
 */
proto.buying.trivia.api.v1.UserTriviaState = {
  USER_TRIVIA_STATE_INVALID: 0,
  USER_TRIVIA_STATE_PRE_START: 1,
  USER_TRIVIA_STATE_RANKINGS_TO_BE_UPDATED: 2,
  USER_TRIVIA_STATE_RANKINGS_UPDATED: 3,
  USER_TRIVIA_STATE_RANKINGS_NOT_STARTED: 4
};

goog.object.extend(exports, proto.buying.trivia.api.v1);
